<!--
 * @description:图文问诊信息
 * @fileName: index.vue
 * @author: kxy
 * @date: 2020-01-02 10:28:44
 * @后台人员: 法夏 ，杨娟
!-->
<template>
    <div id="root"
         :class="['inquiry-root', { setHeight: showAdd }]">
        <!-- navbar -->
        <van-nav-bar class="first-bar"
                     v-if="!showAdd"
                     :title="title"
                     :border="false"
                     left-arrow
                     fixed
                     :style="{ display: pageVisible ? 'none' : 'block' }"
                     :right-text="step === 1 ? '新增药品' : ''"
                     @click-left="onClickLeft"
                     @click-right="toNewMedicine">
        </van-nav-bar>
        <!-- 新增西药药品，组件 -->
        <Add v-if="showAdd"
             @closeadd="closeAdd"
             @addmedicine="addMedicine"></Add>
        <!-- 新增中药药品，组件 -->

        <!-- 去开方，表单信息 -->
        <div class="interrogationInfo"
             v-if="!showAdd">
            <div v-if="step == 0"
                 :class="['main', { pd120: step !== 1 }]">
                <div class="inquirytype"
                     v-if="getInquiryType === 0">
                    <div v-for="item in inquiryTypeList"
                         :key="item.type"
                         :class="[
              'inquirytype-item',
              { active: formItem.inquiryType === item.type },
              { inquiryText: item.type === 2 }
            ]"
                         @click="onToggleInquiryType(item.type)">
                        <van-image class="inquirytype-item_photo"
                                   width="37"
                                   height="37"
                                   :src="item.photo"
                                   round
                                   fit="cover" />
                        <span>{{ item.text }}</span>
                    </div>
                </div>
                <van-cell-group class="interrogationInfo-group">
                    <van-field v-model="formItem.name"
                               class="cell"
                               required
                               clearable
                               label="姓名"
                               placeholder="请输入姓名或手机号搜索患者"
                               @input="inputName" />
                    <van-field class="cell"
                               label="手机号"
                               required>
                        <input class="telphone"
                               slot="input"
                               type="text"
                               @input="handleInput"
                               :value="formItem.phoneNum"
                               maxlength="11"
                               placeholder="用于医生电话回拨和短信提醒" />
                    </van-field>
                    <van-field v-model="idNum"
                               class="cell"
                               :required="idCardMandatorySwitch"
                               type="text"
                               label="身份证号"
                               maxlength="18"
                               placeholder="用药人身份证号码"
                               @input="idCardInput"
                               @change="idCardValid('input')" />
                    <van-field class="cell pAge"
                               label="年龄"
                               required>
                        <input class="customAge"
                               slot="input"
                               type="number"
                               @input="handleInputAge"
                               :value="formItem.customAge"
                               placeholder="请输入年龄"@blur="ageBlurChange" />
                    </van-field>
                    <!-- 性别 -->
                    <van-field v-model="formItem.sex"
                               class="cell"
                               clearable
                               required
                               label="性别">
                        <van-radio-group slot="input"
                                         v-model="formItem.sex">
                            <van-radio name="1">男</van-radio>
                            <van-radio name="2">女</van-radio>
                        </van-radio-group>
                    </van-field>
                    <!-- 用药类型 -->
                    <van-field v-model="formItem.medicineType"
                               class="cell"
                               clearable
                               required
                               label="用药类型">
                        <van-radio-group slot="input"
                                         v-model="formItem.medicineType"
                                         @change="chooseMedicineType">
                            <van-radio name="0">西药</van-radio>
                            <van-radio name="1">中药</van-radio>
                        </van-radio-group>
                    </van-field>
                    <!-- 统筹类型 -->
                    
                    <van-field
                        v-if="containOverallPlanType && overallPlanTypeMap.length > 1"
                        required 
                        is-link
                        label="处方统筹类型"
                        @click="openOverallPlanTypePopup"
                        placeholder="请选择处方统筹类型"
                        value-class="overallPlanTypeText"
                        v-model="overallPlanTypeText"
                        readonly
                        autosize
                    >
                        
                    </van-field>
                    <!-- 预购药品 -->
                    <van-field v-model="getMedicine" v-if="showPreDrug"
                               :class="[
              'cell',
              'disabled-cell-input',
              'inputMedicine',
              { 'input-selected': getMedicine }
            ]"
                               type="textarea"
                               is-link
                               rows="1"
                               label="预购药品"
                               placeholder="请选择预购药品"
                               readonly
                               autosize
                               required
                               @click="toSearchMedicine" />
                    <!-- 中药列表 -->
                    <TcmList ref="tcmList"
                             :medicineParamsCn="medicineParamsCn"
                             :inquiryType="formItem.inquiryType"
                             :cartList="medicineArrCn"
                             v-if="formItem.medicineType == 1 "
                             v-show="showPreDrug"
                             @updateDosageAndUsage="updateDosageAndUsage"
                             @upDateMedicineCn="upDateMedicineCn" />

                    <!-- 西药诊断 -->
                    <DiagnoseWest v-show="formItem.medicineType == 0"
                                  :inquiryType="1"
                                  :selectedList="selectedList"
                                  @handleClickDiagnose="handleClickDiagnose"
                                  @showDiagnose="showDiagnose" />
                    <!-- 中药诊断 -->
                    <DiagnoseCn v-show="formItem.medicineType == 1"
                                :inquiryType="1"
                                :selectedList="selectedListCn"
                                @handleClickDiagnose="handleClickDiagnose"
                                @showDiagnose="showDiagnose" />
                    <!-- 西药诊断弹窗 -->
                    <van-popup class="diagnose-popup"
                               v-model="remarkFlag"
                               position="bottom"
                               :round="true"
                               closeable>
                        <DiagnoseWestPopup v-if="remarkFlag"
                                           :callback="confirmDiacrisis"
                                           :selected-list="activeDiagnose"
                                           @unActive="unActive":sex="formItem.sex" />
                    </van-popup>

                    <!-- 中药诊断弹窗 -->
                    <van-popup class="diagnose-popup"
                               v-model="remarkFlagCn"
                               position="bottom"
                               :round="true"
                               closeable>
                        <DiagnoseCnPopup v-if="remarkFlagCn"
                                         :callback="confirmDiacrisis"
                                         :selected-list="activeDiagnoseCn"
                                         :sex="formItem.sex"@unActive="unActive" />
                    </van-popup>

                    <!-- <van-cell class="no-border diagnose" :required="formItem.inquiryType === 1">
            <div class="box">
              <div class="box-top">
                <p class="box-title">诊断 <span>（最多可选5项）</span></p>
              </div>
              <div class="tips">
                <span
                  v-for="(tip,index) in selectedList"
                  :key="index + Math.random()"
                  :class="['tip',{ active: tip.active }]"
                  @click="handleClickDiagnose(tip)"
                  >{{ tip.diagnosisName }}</span
                >
                <span class="tip" @click="remarkFlag=!remarkFlag">
                  <van-icon name="plus"/> 添加
                </span>
              </div>
            </div>  
          </van-cell> -->
                    <!-- 病情描述 -->
                    <van-cell class="no-border">
                        <div class="box">
                            <div class="box-top">
                                <p class="box-title">病情描述<span>（最多可选5项）</span></p>
                            </div>
                            <div class="tips">
                                <span v-for="(tip, index) in tips"
                                      :key="index + Math.random()"
                                      :class="['tip', { active: tip.active }]"
                                      @click="handleClickMainSuit(tip)">{{ tip.mainSuitName }}</span>
                                <span class="tip"
                                      @click="handleClickMainSuitBtn">
                                    <van-icon name="plus" /> 添加
                                </span>
                            </div>
                        </div>
                    </van-cell>
                    <template v-if="!isNewIM || formItem.inquiryType !== 1">
          <!-- 过敏史 -->
                    <van-cell class="expect van-cell--required no-border">
                        <div class="box">
                            <div class="box-top">
                                <!-- <p class="box-title">过敏史<span>(可多选)</span></p> -->
                                <p class="box-title">过敏史<span>（可多选）</span></p>
                            </div>
                            <div class="tips">
                                <span :class="['tip', { active: hasAllergy === '1' }]"
                                      @click="handleClickAllery('clear')">无</span>
                                <span v-for="item in allergyList"
                                      :key="item + Math.random()"
                                      :class="['tip', { active: item.active }]"
                                      @click="handleClickAllery('add', item)">{{ item.name }}</span>
                                <span class="tip"
                                      @click="handleClickAllergyBtn">
                                    <van-icon name="plus" /> 添加
                                </span>
                            </div>
                        </div>
                    </van-cell>
                    <!-- 肝功能异常 -->
                    <van-field v-model="liverAndRenalFunction"
                               class="cell cell-new-catch"
                               clearable
                               required
                               label="肝、肾功能异常">
                        <van-radio-group slot="input"
                                            @change="changeLiverAndRenalFunction"
                                         v-model="liverAndRenalFunction" >
                            <van-radio name="0">无</van-radio>
                            <van-radio name="1">有</van-radio>
                        </van-radio-group>
                    </van-field>

                    <div class="checkBox"
                         v-if="liverAndRenalFunction==='1'"
                         style="height: 40px;display:flex;item-align:center">
                        <van-checkbox-group v-model="liverAndRenalFunctionSelect"
                                            direction="horizontal"
                                            shape="square"
                                            icon-size="20px">

                            <van-checkbox :name="1"
                                          style="margin-left:20px;font-weight:200">肝功能异常</van-checkbox>
                            <van-checkbox :name="2"
                                          style="margin-left:20px;font-weight:200">肾功能异常</van-checkbox>

                        </van-checkbox-group>
                    </div>

                    <!-- 是否妊娠、哺乳期 -->
                    <van-field v-if="formItem.sex === '2'"
                               v-model="pregnancyAndLactation"
                               class="cell cell-new-catch"
                               clearable
                               required
                               label="是否妊娠、哺乳期">
                        <van-radio-group slot="input"
                                         v-model="pregnancyAndLactation" @change="changePregnancyAndLactation">
                            <van-radio name="0">无</van-radio>
                            <van-radio name="1">有</van-radio>
                        </van-radio-group>
                    </van-field>
                    <div class="checkBox"
                         v-if="pregnancyAndLactation==='1'&&formItem.sex=='2'"
                         style="height: 40px;display:flex;item-align:center">
                        <van-radio-group v-model="pregnancyAndLactationSelect"
                                            direction="horizontal"
                                            shape="square"
                                            icon-size="20px"
                                            v-if="pregnancyAndLactation==='1'&&formItem.sex=='2'">

                            <van-radio :name="1"
                                          style="margin-left:20px;font-weight:200">妊娠期</van-radio>
                            <van-radio :name="2"
                                          style="margin-left:57px;font-weight:200">哺乳期</van-radio>

                        </van-radio-group>
                    </div>
                    <!-- 有无线下确诊 -->
                    <van-field v-model="isDiagnose"
                               class="cell cell-new-catch"
                               clearable
                               required
                               label="是否复诊">
                        <van-radio-group slot="input"
                                         v-model="isDiagnose"
                                         @change="diagnosedChnaged">
                            <van-radio name="1">是</van-radio>
                            <van-radio name="2">否</van-radio>
                        </van-radio-group>
                    </van-field>
                    </template>
        <van-cell class="no-border"
                              v-show="isDiagnose == 1">
                        <div class="box-top"
                             style="margin-bottom: 10px;">
                            <p class="box-title">上传线下就诊的处方或病历<span style="font-size: 14px; color: #999999;">（最多3张）</span></p>
                        </div>
                        <div style="display: flex;">
                            <van-uploader ref="upload"
                                          class="pad16"
                                          :max-count="3"
                                          :after-read="afterReadImage"
                                          v-model="fileList"
                                          :before-read="beforeReadImage"
                                          :before-delete="deleteImage"
                                          :capture="capture"
                                          accept="image/*">
                                <div></div>
                            </van-uploader>
                            <div v-show="fileList.length < 3"
                                 class="add_image"
                                 @click="openShowSheet()"><img src="../../icons/addImage.png"
                                     alt="" /></div>
                        </div>
                    </van-cell>
                    <van-field v-model="chronicRequire"
                               class="cell cell-new-catch"
                               clearable
                               label="慢病病情需要">
                        <van-radio-group slot="input"
                                         v-model="chronicRequire">
                            <van-radio name="1">是</van-radio>
                            <van-radio name="0">否</van-radio>
                        </van-radio-group>
                    </van-field>
                </van-cell-group>

                <div class="main-agreement">
                    <van-checkbox class="main-agreement_checked"
                                  v-model="agreeFlag"></van-checkbox>
                    <p>
                        我已详细阅读并同意<span @click="showAgreement(4)">《问诊知情同意书》</span>和<span @click="showAgreement(3)">《宜贰叁互联网医院服务协议》</span>
                    </p>
                </div>
                <!-- 搜索姓名 -->
                <!-- @click="showNameList = false" -->
                <div v-if="showNameList"
                     class="mask"
                     @click="showNameList = false">
                    <van-list class="nameList"
                              @click.stop>
                        <div v-for="(item, index) in nameList"
                             :key="index"
                             class="item">
                            <div class="left"
                                 @click="handlerNameList(index)">
                                <span class="list-name van-ellipsis"
                                      v-html="onReplaceFont(item.userName, formItem.name, 'username')"></span>
                                <span
                                      class="list-sex">{{ item.sex == 1 ? '男' : '女' }}-{{ item.patientUnifiedAag ? item.patientUnifiedAag || '' : item.age || '' }}</span>
                                <!-- <span class="list-age">{{ item.patientUnifiedAag ? item.patientUnifiedAag || '' : item.age || '' }}</span> -->
                                <span class="list-tel">{{ item.telephone || '' }}</span>
                            </div>
                            <span class="deleteIcon"
                                  @click="deleteNameItem(item)"> <img width="18px"
                                     :src="require('@/icons/delete.png')" /></span>

                        </div>
                    </van-list>
                </div>
            </div>
            <div v-if="step == 0"
                 class="next-fixed-bottom">
                <div class="next"
                     @click="card">去问诊</div>
            </div>
        </div>
        <!-- 西药弹层 -->
        <WesternMedicine @perfOfDeleteMedicine="deleteDiagnoseByMedicine"
                         @finishMedicine="finishMedicine"
                         :step="step"
                         :age="formItem.customAge"
                         :medicineType="formItem.medicineType"
                         :medicineArr="medicineArrCopy"
                         ref="westernMedicineChild" />
        <!-- 中药弹层 -->
        <SearchMedicineCn ref="search"
                          :medicineArrCn="medicineArrCn"
                          v-show="showSearchMedicineCn"
                          @callback="cancelSearchMedicineCn" />
        <!-- 病情描述 -->
        <van-popup class="mainsuit-popup"
                   v-model="mainSuitFlag"
                   position="bottom"
                   :round="true"
                   closeable>
            <!-- 病情描述页面 -->
            <MainSuit v-show="mainSuitFlag"
                      :len="mainSuitLen"
                      @addMainSuit="addMainSuit" />
        </van-popup>
        <!-- 过敏史 -->
        <van-popup class="mainsuit-popup"
                   v-model="allergyFlag"
                   position="bottom"
                   :round="true"
                   closeable>
            <Allergy v-show="allergyFlag"
                     :len="allergyLen"
                     @addAllergy="addAllergy" />
        </van-popup>

        <!-- 购物车 -->
        <van-popup v-model="showCart"
                   position="bottom"
                   :round="true">
            <div class="box">
                <div class="box-top">
                    <span class="box-title">预购药品</span>
                    <img src="../../icons/close.png"
                         alt
                         @click="showCart = false" />
                </div>
                <ul class="cart-goods">
                    <li v-for="(item, index) in medicineArr"
                        :key="index + item.productPref || index + item.pref"
                        class="goods van-hairline--bottom">
                        <div class="goods-left">
                            <div class="goods-name">
                                <span v-if="parseInt(item.prescriptionYn) === 1">Rx</span>
                                <p class="goodsName van-ellipsis">
                                    {{ item.commonName ? item.commonName : item.productName }}
                                </p>
                            </div>
                            <p class="specifications van-ellipsis">
                                {{ item.attributeSpecification }}
                            </p>
                            <p class="producingArea van-ellipsis"
                               v-if="item.drugChannel == 1">
                                {{ item.manufacturer || '' }}
                            </p>
                        </div>
                        <!-- {{ item }} -->
                        <van-stepper :value="item.num"
                                     integer
                                     min="0"
                                     disable-input
                                     class="stepper"
                                     @minus="minus(item, index)"
                                     @plus="plus(item, index)" />
                    </li>
                </ul>
                <van-button class="closeMedicinePup"
                            type="info"
                            size="large"
                            round
                            @click="closeMedicinePup">确定</van-button>
            </div>
        </van-popup>

        <!-- loading -->
        <LoadingComponent :is-show="isShowLoading" />
        <Protocol v-if="pageVisible"
                  :title="agreementTitle"
                  @callback="closeProtocol" />
        <!--  //拦截卡片 -->
        <van-popup v-model="allergyFlagShow"
                   position="bottom"
                   :style="{ height: '80%' }">
            <intercept :cardLit=cardLit
                       @goBack=goBack
                       @next=next />
        </van-popup>
        <!-- 上传 -->
        <van-popup v-model="showUploadImg"
                   position="bottom"
                   :round="true"
                   :style="{ height: '25%' }">
            <div>
                <div style="border-bottom: 0.5px solid #E8E8E8;"
                     class="upload_text"
                     @click="clickPhotosImg">拍照</div>
                <div class="upload_text"
                     @click="clickUploadImg">从手机相册选择</div>
                <div style="height: 5px; background-color: #F7F7F7"></div>
                <div style="margin-top: 15px;"
                     class="upload_text"
                     @click="showUploadImg = false">取消</div>
            </div>
        </van-popup><van-dialog use-slot
                    title="药品未匹配到"
                    v-model="showDrugWarning"
                    show-cancel-button
                    confirm-button-text="去添加"
                    confirm-button-color="#01b956"
                    @confirm="haiDianAddConfirm">
            <div style="padding: 15px; overflow-y: scroll; max-height: 200px;">
                以下药品在问诊平台中未自动匹配到相关药品，请在预购药品中手动添加
                <div style="padding: 10px 0" v-for="(item,index) in showDrugWarningInfo"
                     :key="index">
                     <span>{{index+1}}.</span> {{item.commonName}}
                     <small v-if="item.attributeSpecification" style="color:#999999">({{item.attributeSpecification}})</small> </div>
            </div>
        </van-dialog>
  <!-- IM优化等待医生弹窗 -->
  <van-overlay :show="isAwaitDoctor" position="center">
    <div class="dia-context">
      <van-image width="90" height="90" src="https://tuan-static.ybm100.com/ykq/miniapp/images/newHomeSource/inquiry/doctor-photo-boy.png" />
      <div class="diagnose-finish-title">正在为您接入医生</div>
      <div class="diagnose-finish-text">请耐心等候…</div>
    </div>
  </van-overlay>

    <van-dialog
      use-slot
      title="未匹配到医生"
      v-model="dialogShow"
      confirm-button-text="我知道了" confirm-button-color="black"
    >
      <div class="box" style="padding: 15px;">
        <div class="box_text" style="text-indent: 2em;">您好，根据平台监管要求，本次问诊涉及了限制类抗菌药物，对开方医生职称有要求，</div>
        <div class="box_text" style="text-indent: 2em;">当前暂无可开方医生，您可以稍后重新发起，或去除限制类药物重新问诊。涉及的限制类的物:</div>
      </div>
      <div style="padding: 15px; overflow-y: scroll; max-height: 100px; padding-top: 0px;">
        <div v-for="(item,index) in drugLimitDockerList" class="line" :key="item.commonName+item.limitTypeName+index" style="color:#07A9F0;">{{index+1}}、{{item.commonName}}（{{item.limitTypeName}}）</div>
      </div>
    </van-dialog>
    <!-- 统筹类型选择弹框 -->
        <van-popup
            v-model:show="showOverallPlanTypePopup"
            :closeable="false"
            position="bottom"
            :style="{ height: `${overallPlanTypeMap.length * 1.56 + 1.6}rem` }"
            safe-area-inset-bottom
        >
            <van-cell class="overallPlanType" 
            v-for="item in overallPlanTypeMap" 
            :key="item.value" 
            center
            @click="selectOverallPlanType(item.label)"
            >{{ item.label }}</van-cell>
            <van-cell class="overallPlanType" @click="cancelOverallPlanTypePopup"  center>取消</van-cell>
        </van-popup>
        
    </div>
</template>

<script>
import Cookies from "js-cookie"
import WesternMedicine from './components/westernMedicine'
import Protocol from '@/components/indexTextProtocol'
import DiagnoseWestPopup from '@/components/diagnoseWestPopup'
import DiagnoseCnPopup from '@/components/diagnoseCnPopup'
import MainSuit from '@/components/mainSuit'
import Allergy from '@/components/allergy'
import LoadingComponent from '@/components/Loading'
import DiagnoseWest from './components/diagnoseWest'
import DiagnoseCn from './components/dignoseCn'
import TcmList from '@/components/chinese-medicine/add-chinese-medicinal'
import SearchMedicineCn from '@/components/chinese-medicine/prescription.vue'
import intercept from "./intercept.vue"
import { irritabilityQueryList, getDefaultAllergy } from "@/api/video"
import {
    getMainSuitList,
    searchPatientInfo,
    patientInfoAndGotoInquir,
    getAllergy,
    getDiagnoseByMedicine,
    getInquiryAreaRuleByOrganSign,
    uploadFile,

} from '@/api/index'
import { getPrePrescriptionById } from '../../api/haidian'
import { getSign, limitDrugAudit } from '../../api/video'
import { initLog } from '@/utils/'
import {
  queryMedicineList,
  drugsList,
  unitList,
  rateList,
  getMethod,
  getDose,
  updateMedicine,
  suggestMedicine,
  getMedicineByBarcode,
  queryDrugstorePackageInquiryType,
  checkInquiryConfig,
  getMedicineByBarcodeNew,
  getDrugstoreDrugSwitch,
  postUpdateIsNotShowStatus,
  checkOrganSignSwitch,
  getOverallPlanTypeList
} from '../../api/index'

import { getCookie } from '@/utils/auth'
import Add from './components/newMedicine'
import { Dialog } from "vant";
let canSubmit
const noticeTextArr = [
    '暂无搜索结果，请使用关键词搜索或【新增药品】', //扫码
    '暂无搜索结果，请调整关键词搜索或【新增药品】' //关键字
]
let liverAndRenalFunctionSelect;
let pregnancyAndLactationSelect;
let birthday;
export default {
    //  beforeRouteLeave (to, from, next) {

    //   if(to.name=="home"){

    //  from.meta.keepAlive=false
    //     next()

    //   }
    //   else{
    //     from.meta.keepAlive=true
    //     next()
    //   }
    // },
    beforeRouteEnter (to, from, next) {
        if (from.name == "home") {

            next(vm => {
                vm.$router.go(0)

            })

        }

        if (from.path == "/allergySelect") {

            next(vm => {
                if (vm.$route.query.value != null && vm.$route.query.value != undefined && vm.$route.query.value != "" && vm.$route.query.value.name) {
                    let value = { name: vm.$route.query.value.name, active: false, id: vm.allergyList.length, value: vm.$route.query.value }
                    if (!vm.allergyList.find(item => {
                        return item.name == value.name
                    })) {
                        vm.allergyList.push(value)
                        vm.handleClickAllery('add', value)
                    } else {
                        let arr = vm.allergyList.find(item => {
                            return item.name == value.name
                        })

                        arr.active = true
                    }
                }
            })
}
        if (from.path == "/haidianHome") {
        next(vm => {
vm.checkHaidianFn()
            })
        }
        next()
    },

    data () {
        return {
            showPreDrug:false, // 显示预购药品
            drugLimitDockerList:[],// 未匹配医生
            dialogShow:false,// 抗菌类药品提示框
            isHaiDian: false, // 是否为海典问诊westernMedicineBring: 0,
            chineseMedicineBring: 0,
            isFirst: true,
            isIOS: false,
            showDrugWarning: false,
            showDrugWarningInfo: [],allergyListLength: "",
            cardLit: [],
            allergyFlagShow: false,
            medicineParamsCn: {}, // 中药用法用量对象
            showSearchMedicineCn: false,
            medicineArrCn: [], // 中药
            defaultAllergy: [], // 默认诊断
            defaultMainSuit: [], // 默认病情描述
            mainSuitLen: 0, // 已选中的病情描述字数
            allergyLen: 0, // 已选中的过敏史字数
            showNoData: false, // 是否展示搜索缺省
            noticeText: '', // 缺省文字
            getInquiryType: 0, // 模拟接口返回
            isKeydown: false, // 记录搜索框上一次操作是否是键盘输入
            remarkFlag: false, // 西药诊断弹层
            remarkFlagCn: false, // 中药诊断弹层
            mainSuitFlag: false, // 病情描述弹层
            allergyFlag: false, // 添加过敏史弹层
            diagnosis: '', // 诊断字符串
            diagnosisCode: '', // 诊断code码，提交到后台
            diagnosisCn: '', // 诊断字符串
            diagnosisCodeCn: '', // 诊断code码，提交到后台
            selectedList: [], // 诊断数据(西药)
            selectedListCn: [], // 诊断数据(中药)
            showUploadImg: false, // 上传图片弹窗
            fileList: [], // 复诊凭证
            capture: null, // 上传调用
            inquiryTypeList: [
                // 问诊类型枚举
                {
                    photo: require('../../icons/inquiry_text.png'),
                    text: '图文问诊',
                    type: 1
                },
                {
                    photo: require('../../icons/inquiry_video.png'),
                    text: '视频问诊',
                    type: 0
                }
            ],
            agreementTitle: '', // 协议名称
            agreementNum: 3, // 协议number
            pageVisible: false, // 协议弹层
            agreeFlag: true, // 协议
            isShowLoading: false, // 菊花图
            showAdd: false, //显示新增
            title: '填写问诊人信息',
            formItem: {
                inquiryType: 1, // 1 - 图文问诊，0 - 视频问诊
                name: '', // 名字
                phoneNum: '', // 电话号
                customAge: '', // 年龄
                sex: '1', // 性别
                medicineType: '0'
            },
            step: 0, // 0去开方 1预购药品
            nameList: {}, // 输入姓名后接口返回值
            idNum: '', // 身份证
            pregnancyAndLactation: '0', // 是否妊娠、哺乳期	0 否  1 是
            pregnancyAndLactationSelect: 1,//否妊娠、哺乳期选择
            liverAndRenalFunction: '0', // 肝、肾功能异常	0无   1 有
            liverAndRenalFunctionSelect: [1, 2], //肝、肾功能异常选择
            hasAllergy: '1', // 有无过敏史
            allergyList: [], // 过敏史数组
            selectedAllergy: [], //选中的过敏史
            allergySymptomExplain: '', // 过敏史说明
            isDiagnose: '1', // 线下是否确诊
            chronicRequire: '0', // 是否慢病病情
            checkImageList: [], // 上传复诊凭证
            mainSuit: '', // dialog内病情描述
            medicine: '', // 药品名称
            medicineArr: [], // 购物车药品清单
            medicineArrCopy: [], // 购物车药品清单
            showNameList: false, // 遮罩层
            tips: [],
            searchVal: '', // 搜索关键字
            listData: [], // 药品搜索清单
            pageNum: 1,
            pageSize: 30,
            list: [], // 药品模糊查询
            showCart: false,
            patientGuid: '', // 患者id
            roomNumber: '', // 房间号
            employeeId: '', // 视频参数
            userSign: '', // 视频参数
            canSubmit: true, // 去开方按钮点击防重flag
            organSign: '', // 机构号
            currentMedicine: {}, // 当前添加的药品
            showNewMedicine: false,
            inquiryAreaRule: {},isNewIM: false, // 是否走图文问诊IM优化
            isAwaitDoctor: false, // 是否显示等待医生弹窗
            saveMediceArr: [],
            idCardMandatorySwitch:false,//身份证动态校验,
            showOverallPlanTypePopup: false, // 统筹类型弹窗
            containOverallPlanType: false, // 是否需要显示统筹类型
            overallPlanTypeMap: [], // 统筹类型列表
            overallPlanTypeText: '', // 统筹类型
        }
    },
    components: {
        DiagnoseWest,
        WesternMedicine,
        Add,
        LoadingComponent,
        DiagnoseWestPopup,
        DiagnoseCnPopup,
        MainSuit,
        Allergy,
        Protocol,
        DiagnoseCn,
        TcmList,
        SearchMedicineCn,
        intercept
    },
    computed: {
        activeDiagnose: function () {
            return this.selectedList.filter(item => {
                return item.active === true
            })
        },
        activeDiagnoseCn: function () {
            return this.selectedListCn.filter(item => {
                return item.active === true
            })
        },
        getMedicine: function () {
            if (this.formItem.medicineType == 0) {
                const nameArr = []
                this.medicineArr.map(item => {
                    const name = item.commonName ? item.commonName : item.productName

                    nameArr.push(name)
                })
                return nameArr.join(', ')
            } else {
                // 中药
                const nameArr = []
                this.medicineArrCn.map(item => {
                    const name = item.commonName ? item.commonName : item.productName

                    nameArr.push(name)
                })
                return nameArr.join(', ')
            }
        },
 
    },
    watch: {
        pregnancyAndLactationSelect (newValue) {
            if (!newValue) {
                this.pregnancyAndLactation = "0"
            }
        },
        liverAndRenalFunctionSelect (newValue) {
            if (newValue.length == 0) {
                this.liverAndRenalFunction = "0"
            }
        },
        liverAndRenalFunction (newValue) {
            if (newValue.length == "1") {
                // this.liverAndRenalFunctionSelect = [1, 2]

            }
        },
        pregnancyAndLactation (newValue) {
            if (newValue == "1") {
                // this.pregnancyAndLactationSelect = 1
            }
        },
        medicineArr: {
            handler (newValue, oldValue) {
                let str = JSON.stringify(newValue);
                let obj = JSON.parse(str);
                this.medicineArrCopy = obj
            },
            deep: true // 深度监听对象内部属性的变化
        },
        medicineArrCn: function (val) {
            if (val.length === 0) {
                this.medicineParamsCn = {}
            }
        },
        nameList: function (nVal, oVal) {
            if (nVal.length !== 0 && this.nameList !== 0) {
                this.showNameList = true
            } else {
                this.showNameList = false
            }
        },
        'formItem.phoneNum': {
            handler (n) {
                this.formItem.phoneNum = n.replace(/[^\d]/g, '')
            }
        },
        'formItem.customAge': {
            handler (n) {
                this.formItem.customAge = n.toString().replace(/[^\d]/g, '')
                if (this.formItem.customAge.length > 3) {
                    this.formItem.customAge = this.formItem.customAge.substr(0, 3)
                }
            }
        },
        deep: true
    },
    activated(){
        this.step = 0; //每次都初始化为去问诊
        
    },  
    async created () {

            this.checkOrganSignSwitch()
            // todo
            this.step = 0; //每次都初始化为去问诊this.getZWSwitch();
            // 隐藏底部栏
            window.location.href = 'protocol://action/hideBottomTab'
            canSubmit = true
            this.getInquiryTypes() // 获取问诊权限
            await this.getAllergyData() // 获取过敏史
            this.getRemark() // 获取病情描述
            this.cacheInfo() // 获取本地缓存
            this.getInquiryAreaSwitch() // 获取问诊区域|门店优化配置
            this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            console.log(`----bug 当前设备是 ${navigator.userAgent} ${this.isIOS}`);
            if (this.$route.query.type === 'agreement') {
                this.$nextTick(() => {
                    window.scrollTo(10000, 10000)
                })}
            if (this.$route.query.thirdPartyPrePrescriptionId != null && this.$route.query.thirdPartyPrePrescriptionId != undefined) {
                    this.isHaiDian = true
                } else {
                    this.isHaiDian = false
            }
            // 检测成功，去问诊
            window.handleWIFIstate = data => {
                this.goInquiry()
            }
            // 检测失败，弹出提示
            window.cancelWiFi = () => {
                this.isShowLoading = false
                canSubmit = true
            }

            window.callbackPhotoWithCancle = () => {

            }
            // 是否开启相册弹窗
            window.callbackPhotoWithSure = () => {
                this.showUploadImg = true;
            }
            // 获取统筹类型列表
            const organSign = getCookie('native_organSign')
            console.log(organSign, 'organSign------------');
            this.getOverallPlanTypeData(organSign) // 获取统筹类型列表
        },
    mounted () {
        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, null)
            window.addEventListener('popstate', this.fnback, false)
        }
    },
    destroyed () {
        // 清除事件绑定 组织默认操作
        window.addEventListener('popstate', this.fnback, false)
    },
    methods: {
        changeLiverAndRenalFunction(val){
                // if(val == 1) {
                //     debugger
                //     this.liverAndRenalFunctionSelect = [1,2]
                // }
        },
        changePregnancyAndLactation(val){
            if (val == "1") {
                this.pregnancyAndLactationSelect = 1
            }
        },

         async checkOrganSignSwitch(){
            try {
                let res = await checkOrganSignSwitch({ organSign: getCookie('native_organSign') })
                console.log(res,"---tjy")
                if(res.data.code == 0) {
                 this.showPreDrug = !(res.data.result && res.data.success)
                }
            } catch (error) {
            }
        },
        async getZWSwitch () {
            try {
                let res = await getDrugstoreDrugSwitch({});
                if (res.data.code == 0) {
                    this.westernMedicineBring = res.data.result.westernMedicineBring;
                    this.chineseMedicineBring = res.data.result.chineseMedicineBring;
                } else {
                    this.$toast({
                        message: res.msg
                    })
                }
            } catch (error) {

            }

        },
        openShowSheet () {
            if (this.isIOS) {
                this.showUploadImg = true;
            } else {
                window.location.href = `protocol://action/open_photo_album`
            }
        },
        clickPhotosImg () {
            this.showUploadImg = false;
            this.capture = 'camera';
            this.$nextTick().then(() => {
                this.$refs.upload.chooseFile()
            });
        },
        clickUploadImg () {
            this.showUploadImg = false;
            this.capture = null;
            this.$nextTick().then(() => {
                this.$refs.upload.chooseFile()
            });
        },
        // 图片上传
        async afterReadImage (file) {

            file.status = "uploading";
            file.message = "上传中";
            var files = this.dataURLtoFile(file.content, file.file.name);
            console.log(files);
            try {
                var res = await uploadFile({ file: files })
                if (res.data.code == 0) {
                    file.status = "done";
                    file.message = "上传成功";
                    this.checkImageList.push(res.data.result)
                } else {
                    this.$toast({
                        message: res.data.msg || ''
                    })
                    file.status = "failed";
                    file.message = "上传失败";
                }
            } catch (error) {
                this.$toast({
                    message: error.msg || '上传失败'
                })
                file.status = "failed";
                file.message = "上传失败";
            }
            console.log(res);
        },
        beforeReadImage (file, detail) {
            if (!file.size || file.size <= 0) {
                return false
            }

            if (
                file.type !== "image/jpeg" &&
                file.type !== "image/jp2" &&
                file.type !== "image/bmp" &&
                file.type !== "image/gif" &&
                file.type !== "image/png" &&
                file.type !== "image/tiff" &&
                file.type !== "image/exif" &&
                file.type !== "image/wbmp" &&
                file.type !== "image/mbm"
            ) {
                this.$toast({
                    message: '请上传正确的图片格式'
                })
                return false;
            }
            return true;
        },
        dataURLtoFile (dataurl, filename) {
            //将base64转换为文件
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        deleteImage (file, name) {
            this.fileList.splice(name.index, 1);
            this.checkImageList.splice(name.index, 1);
            console.log(this.checkImageList);
        },
        /* 校验 lwq getInquiryAreaRuleBefore*/
        card () {
            if (!this.checkedSubmit()) {
                return
            }
            // 检验有无身份证，身份证年龄赋值给年龄
            if (this.idNum && this.checkIDCard(this.idNum.toUpperCase())) {
                this.formItem.customAge = this.getAgeByIdNO(this.idNum)
            }console.log(this.liverAndRenalFunctionSelect)
            if (this.liverAndRenalFunctionSelect.length == 2) {
                liverAndRenalFunctionSelect = 3
            } else if (this.liverAndRenalFunctionSelect.length == 0) {
                liverAndRenalFunctionSelect = null
            } else {
                liverAndRenalFunctionSelect = this.liverAndRenalFunctionSelect.join()
            }
            if (this.liverAndRenalFunction == "0") {
                liverAndRenalFunctionSelect = null
            }
            //if (this.pregnancyAndLactationSelect.length == 2) {
             //   pregnancyAndLactationSelect = 3
           // } else if (this.pregnancyAndLactationSelect.length == 0) {
             //   pregnancyAndLactationSelect = null
           // } else {
             //   pregnancyAndLactationSelect = this.pregnancyAndLactationSelect.join()
           //  }
    pregnancyAndLactationSelect = this.pregnancyAndLactationSelect
            if (this.pregnancyAndLactation == "0" || this.formItem.sex == '1') {
                pregnancyAndLactationSelect = null
            }
            let getParamsData = this.getParams();
            let params = getParamsData.params;

            function getBirthdayByIdNO (IdNO) {
                let birthday = "";
                if (IdNO.length == 18) {
                    birthday = IdNO.substr(6, 8);
                    return birthday.replace(/(.{4})(.{2})/, "$1$2");
                } else if (IdNO.length == 15) {
                    birthday = "19" + IdNO.substr(6, 6);
                    return birthday.replace(/(.{4})(.{2})/, "$1$2");
                } else {
                    return "";
                }
            }
            console.log(this.allergyList)
            let integerList = this.allergyList.filter(item => {
                return item.active == true && item.value
            })
            let integerDefaultList = this.allergyList.filter(item => {
                return item.active == true && !item.value
            })
            integerList = integerList.map(item => {
                return item.name
            })
            integerDefaultList = integerDefaultList.map(item => {
                return item.name
            })
            integerList.push(...integerDefaultList)
            birthday = getBirthdayByIdNO(params.idCard)
            console.log(params)
            let data = {
                birthday: birthday,
                age: Number(params.customAge),
                sex: Number(params.sex),
                healthSituation: liverAndRenalFunctionSelect == null ? null : Number(liverAndRenalFunctionSelect),
                womenSituation: pregnancyAndLactationSelect == null ? null : Number(pregnancyAndLactationSelect),
                integerList: integerList,
                organSign: getCookie('native_organSign'),
                diagnosisNames: params.lastDiagnosis.diagnosis == "" ? [] : params.lastDiagnosis.diagnosis.split('|'),
                //drugs:params.lastDiagnosis.prescriptionDetail.map(item=>{return item.commonName})
            }
            if (this.formItem.medicineType == 0) {
                data.drugs = params.lastDiagnosis.prescriptionDetail.map(item => { return item.commonName })
                data.drugDtoList = params.lastDiagnosis.prescriptionDetail.map(item => {
                    return {
                        commonName: item.commonName,
                        pref: item.pref,
                        quantity: item.quantity,
                        singleDose:item.singleDose,
                        useFrequency:item.useFrequency,
                        singleUnit:item.singleUnit,
                        directions:item.directions,
                    }
                })
                let list = [];
                this.selectedList.forEach((item) => {
                    if (item.active) {
                        list.push(item.diagnosisCode)
                    }
                })
                data.diagnosisCodes = list
            } else {
                data.drugs = params.lastDiagnosis.prescriptionTCMDetail.map(item => { return item.commonName })
                data.drugDtoList = params.lastDiagnosis.prescriptionTCMDetail.map(item => {
                    return {
                        commonName: item.commonName,
                        pref: item.pref,
                        quantity: item.quantity,
                    }
                })
                let list = [];
                this.selectedListCn.forEach((item) => {
                    if (item.active) {
                        list.push(item.diagnosisCode)
                    }
                })
                data.diagnosisCodes = list
            }
           // 判断是否走图文问诊优化
      if(this.isNewIM){
        // 缓存参数数据，等待下个页面获取
       data.medicineType = Number(this.formItem.medicineType)
        localStorage.setItem('limitDrugAudit', JSON.stringify(data))
        // data = {}
        // 图文问诊优化时，直接跳转，不做第一次药品限制检测
        // 只有当类型为图文问诊是才有效
        if(this.formItem.inquiryType === 1) {
            this.getInquiryAreaRuleBefore()
            return
        }
      }

       this.isShowLoading = true;
       console.log(data.diagnosisCodes)
       data.medicineType = Number(this.formItem.medicineType)
       debugger
            limitDrugAudit(data).then(res => {
                this.isShowLoading = false
                if (res.result == null || res.result.length == 0) {
                    this.getInquiryAreaRuleBefore()
                } else {
                    this.cardLit = res.result
                    this.allergyFlagShow = true
                }
                console.log(res)
            },
                err => {
                    this.isShowLoading = false
                    this.getInquiryAreaRuleBefore()
                })
            this.isShowLoading = false
        },
        /**
         * @description: 切换用药类型
         * @param {}
         * @param {}
         * @return
         */
        chooseMedicineType (val) {
            window.webSdk.track('handleClickMedicineType', {
                medicineType: val
            })
        },
        /**
         * @description: 更新父组件中的中药
         * @param {}
         * @param {}
         * @return
         */
        upDateMedicineCn (pref, flag = true) {
            // 删除listdata中的药品
            this.$refs.search.deleteMedicineFromFather(pref, flag)
        },
        /**
         * @description: 更新父组件的中药用法用量
         * @param {}
         * @param {}
         * @return
         */
        updateDosageAndUsage (item) {
            this.medicineParamsCn = item
        },
        cancelSearchMedicineCn (item) {
            console.log("中药碳层!");
            this.showSearchMedicineCn = false
            this.medicineArrCn = item
            this.step = 0
            this.title = '填写问诊人信息'

            let flag = false;
            this.medicineArrCn.forEach(res => {
                if (this.saveMediceArr.findIndex(k => k.pref === res.pref) == -1) {
                    flag = true;
                }
            })
            this.saveMediceArr.forEach(res => {
                if (this.medicineArrCn.findIndex(k => k.pref === res.pref) == -1) {
                    flag = true;
                }
            })
            console.log(this.medicineArrCn, "ooo")
            console.log(this.saveMediceArr, "uuu")
            if (flag) {
                if (this.formItem.medicineType == 0) {
                    this.selectedList = [];
                } else {
                    this.selectedListCn = [];
                }
                if (this.medicineArrCn.length) {
                    this.getDiagnosisByMedicine()
                }
            }
        },
        showDiagnose () {
            if (this.formItem.medicineType == 0) {
                this.remarkFlag = true
            } else {
                this.remarkFlagCn = true
            }
        },
        /**
         * @description: 替换搜索关键字为红字
         * @param {string, string} oraignString - 要匹配的字符串， searchVal - 匹配关键字
         * @return: string 返回匹配后的完整的字符串
         */
        onReplaceFont (oriStr, searchVal, type) {
            // 匹配姓名，没有大小写问题
            if (type === 'username') {
                let reg = new RegExp(searchVal, 'g')
                let replaceHtml = '<font style="color:#01B956">' + searchVal + '</font>'
                return oriStr.replace(reg, replaceHtml)
            }

            const firstStr =
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1
                    ? oriStr.slice(
                        0,
                        oriStr.toLowerCase().indexOf(searchVal.toLowerCase())
                    )
                    : ''
            const secondStr = `<span
        style="color:#01B956"
      >
        ${oriStr.slice(
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()),
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) +
                searchVal.length
            )}
      </span>`
            const thirdStr =
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1
                    ? oriStr.substr(
                        oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) +
                        searchVal.length
                    )
                    : oriStr
            return firstStr + secondStr + thirdStr
        },
        /**
         * @description:根据药品id删除关联诊断
         * @param {String} 药品pref
         * @return {void}
         */
        deleteDiagnoseByMedicine (pref) {
            for (let i = 0; i < this.selectedList.length; i++) {
                if (!this.selectedList[i].active && this.selectedList[i].pref == pref) {
                    this.selectedList.splice(i, 1)
                    i--
                }
            }
        },
        /**
         * @description:根据预购药品获取诊断
         */
        async getDiagnosisByMedicine () {
            try {
                var mediceArr = [];
                if (this.formItem.medicineType == 1) {
                    mediceArr = this.medicineArrCn;
                } else {
                    mediceArr = this.medicineArr;
                }
                this.isShowLoading = true
                let druginfoList = mediceArr.map(item => {
                    return {
                        pref: item.pref || item.productPref,
                        productName: item.commonName || item.productName
                    }
                })
                const params = {
                    patientGuid: this.patientGuid,
                    druginfoList
                }
                const res = await getDiagnoseByMedicine(params)
                // todo  选择药品后，推荐显示的诊断做以下过滤if (res.code === 0) {
                    this.insertDiagnoseFromReq(res.result) // 将返回的诊断插入到页面
                }
             catch (err) {
                console.log(err & err.msg)
            } finally {
                this.isShowLoading = false
            }
        },
        /**
         * @description:将接口返回的诊断插入到页面
         * @param {Array} 接口返回的res
         * @return {void}
         */
        insertDiagnoseFromReq (items) {
            items.forEach(item => {
                // 诊断是否高亮
                if (item.diagnosisType == 1) {
                    item.active = true
                } else {
                    item.active = false
                }
            })
            // items与selectedList 去重
            this.selectedList.forEach(s => {
                items.forEach((item, index) => {
                    if (s.diagnosisName === item.diagnosisName) {
                        items.splice(index, 1)
                    }
                })
            })
            let suggestDiagnose = items.filter(item => {
                // 推荐诊断------不高亮
                return item.diagnosisType == 2
            })
            //根据药品数量，判断应该取几条推荐诊断
            let len = 0
            switch (this.medicineArr.length) {
                case 1:
                    len = 3
                    break
                case 2:
                    len = 6
                    break
                case 3:
                    len = 7
                    break
                case 4:
                    len = 8
                    break
                case 5:
                    len = 9
                    break
                default:
                    break
            }
            for (let i = 0; i < this.selectedList.length; i++) {
                const index = this.medicineArr.findIndex(item => {
                    return item.pref == this.selectedList[i].pref
                })
                if (this.selectedList[i].active === false && index === -1) {
                    this.selectedList.splice(i, 1)
                    i--
                }
            }
            suggestDiagnose = suggestDiagnose.slice(0, len)
            suggestDiagnose.forEach(item => {
                this.selectedList.push(item)
            })
            if (this.formItem.medicineType == 1) {
                // 展示中药搜索
                this.saveMediceArr = JSON.parse(JSON.stringify(this.medicineArrCn));
            } else {
                this.saveMediceArr = JSON.parse(JSON.stringify(this.medicineArr));
            }
        },
        /**
         * @description:诊断组件触发，取消诊断项高亮
         * @param {Number} 诊断项在selectedList的下标
         * @return {void}
         */
        unActive (index) {
            let obj =
                this.formItem.medicineType == 0
                    ? this.selectedList
                    : this.selectedListCn
            obj[index].active = false
        },
        /**
         * @description:表单页面，点击诊断项
         * @param {Object} 诊断项
         * @return {void}
         */
        handleClickDiagnose (item) {
            if (item.active === false) {
                const result = this.checkDiagnose(item.diagnosisName)
                if (result) {
                    item.active = true
                }
            } else {
                item.active = false
            }
        },
        /**
         * @description:表单页面，点击诊断项
         * @param {Object} 诊断项
         * @return {void}
         */
        handleClickMainSuit (item) {
            if (item.active === false) {
                const result = this.checkMainSuit(item.mainSuitName)
                if (result) {
                    item.active = true
                }
            } else {
                this.mainSuitLen -= item.mainSuitName.length
                item.active = false
            }
        },
        /**
         * @description:点击病情描述添加按钮
         */
        handleClickMainSuitBtn () {
            const activeItems = this.tips.filter(item => {
                return item.active === true
            })
            if (activeItems.length === 5) {
                this.$toast({
                    message: '病情描述最多5条'
                })
                return false
            }

            this.mainSuitFlag = true
        },
        /**
         * @description:点击过敏史添加按钮
         * @param: {}
         * @param: {}
         * @return:
         */
        handleClickAllergyBtn () {
            //this.allergyFlag = true
            if (this.allergyList.length == this.allergyListLength + 5) {
                this.$toast({
                    message: '过敏史最多添加5个'
                })
                return
            }
            this.$router.replace({
                path: "/allergySelect"
            })
            this.allergyLen = this.allergySymptomExplain.length
        },
        /**
         * @description:判断病情描述是否超出50个字
         * @return {Boolean}
         */
        checkMainSuit (str) {
            let num = str.length
            this.tips.forEach(item => {
                if (item.active === true) {
                    num += item.mainSuitName.length
                }
            })
            if (num > 195) {
                this.$toast({
                    message: '病情描述字数超限'
                })
                return false
            } else {
                const activeItems = this.tips.filter(item => {
                    return item.active === true
                })
                if (activeItems.length === 5) {
                    this.$toast({
                        message: '病情描述不能超过5个'
                    })
                    return false
                }
                this.mainSuitLen = num
                return true
            }
        },
        /**
         * @description:判断诊断是否超出50个字
         * @return {Boolean}
         */
        checkDiagnose (Str) {
            let num = Str.length
            let obj =
                this.formItem.medicineType == 0
                    ? this.selectedList
                    : this.selectedListCn
            obj.forEach(item => {
                if (item.active === true) {
                    num += item.diagnosisName.length
                }
            })
            if (num > 50) {
                this.$toast({
                    message: '诊断字数超限'
                })
                return false
            } else {
                const activeItems = obj.filter(item => {
                    return item.active === true
                })
                if (activeItems.length === 5) {
                    this.$toast({
                        message: '诊断不能超过5个'
                    })
                    return false
                } else {
                    return true
                }
            }
        },
        /**
         * @description:根据条形码搜药
         * @param: {}
         * @param: {}
         * @return:
         */
        async getMedicineByQrcode (data) {
            const params = {
                barCode: data,
                organSign: getCookie('native_organSign')
            }
            this.isShowLoading = true
            try {
                const res = await getMedicineByBarcode(params)
                window.webSdk.track('ds_page_scan_res', {
                    organSign: getCookie('native_organSign'),
                    barCode: data,
                    num: (res.result && res.result.length) || 0,
                    pref: (res.result && res.result.pref) || 0
                })
                if (res.result !== null) {
                    this.$toast({
                        message: '扫码药品添加成功',
                        duration: 500
                    })
                    // 判断购物车里是否已经添加该药品
                    const index = this.medicineArr.findIndex(item => {
                        return item.pref === res.result.pref
                    })
                    if (index !== -1) {
                        // 如果有了
                        this.listData = [res.result]
                        this.plus(this.medicineArr[index], 0)
                        this.handleData()
                    } else {
                        // 如果没有
                        this.$set(res.result, 'num', 0)
                        this.$set(res.result, 'scanText', data)
                        this.listData = [res.result]
                        this.plus(res.result)
                        this.handleData()
                    }
                } else {
                    this.listData = []
                    this.showNoData = true
                    this.noticeText = noticeTextArr[0]
                }
            } catch (err) {
                console.log(err && err.msg)
            } finally {
                this.isShowLoading = false
            }
        },
        /**
         * @description:自定义病情描述
         * @param: {}
         * @param: {}
         * @return:
         */
        addMainSuit (str) {
            if (!str) {
                this.mainSuitFlag = false
                return false
            }
            const tip = {
                mainSuitName: str,
                active: true
            }
            this.mainSuitFlag = false
            this.mainSuitLen += str.length
            //  let index = this.getFirstDefaultMainSuitIndex()
            // this.tips.splice(index,0,tip)
            this.tips.push(tip)
        },
        /**
         * @description:获取第一个常用诊断的下标
         * @return {number} index
         */
        getFirstDefaultMainSuitIndex () {
            for (var i = 0; i < this.tips.length; i++) {
                if (this.tips[i].id !== undefined) {
                    return i
                }
            }
        },
        /**
         * @description:获取第一个常用过敏史的下标
         * @return {number} index
         */
        getFirstDefaultAllergyIndex () {
            for (var i = 0; i < this.allergyList.length; i++) {
                if (this.allergyList[i].id !== undefined) {
                    return i
                }
            }
        },
        /**
         * @description:自定义过敏史
         */
        addAllergy (str) {
            if (!str) {
                this.allergyFlag = false
                return false
            }
            this.hasAllergy = '2'
            this.allergyFlag = false
            const obj = {
                name: str,
                active: true,
                id: this.allergyList.length + 100
            }
            // const index = this.getFirstDefaultAllergyIndex()
            // this.allergyList.splice(index,0,obj)
            this.allergyList.push(obj)
            let s = ''
            this.allergyList.forEach(item => {
                if (item.active) {
                    s += ' ' + item.name
                }
            })
            this.allergySymptomExplain = s.trim()
        },
        /**
         * @description:获取问诊权限
         * @return: getInquiryType 问诊权限
         */
        async getInquiryTypes () {
            try {
                this.isShowLoading = true
                const res = await queryDrugstorePackageInquiryType()
                this.getInquiryType =
                    res.result.inquiryType === null ? 0 : res.result.inquiryType
                if (this.getInquiryType === 1) {
                    this.formItem.inquiryType = 0
                } else if (this.getInquiryType === 2) {
                    this.formItem.inquiryType = 1
                }
                window.scroll(0, 0)
            } catch (err) {
                console.log(err && err.msg)
            } finally {
                this.isShowLoading = false
            }
        },
        formSubmit () {
            return false
        },
        handleInput (e) {
            this.formItem.phoneNum = e.target.value
        },
        handleInputAge (e) {
            this.formItem.customAge =
                e.target.value < '0'
                    ? '0'
                    : e.target.value > 150
                        ? 150
                        : e.target.value
        },
        /**
         * @description: js调原生方法
         * @param: {String <url>} 传入app协议
         * @return: void
         */
        onH5GoInApp (url) {
            const WVJBIframe_1 = document.createElement('iframe')
            WVJBIframe_1.style.display = 'none'
            WVJBIframe_1.src = url
            document.documentElement.appendChild(WVJBIframe_1)
            setTimeout(function () {
                document.documentElement.removeChild(WVJBIframe_1)
            }, 0)
        },
        /**
         * @description: 获取过敏史
         * @param {}
         * @return:
         */
        async getAllergyData () {
            try {
                const res = await getDefaultAllergy({})
                if (res.code === 0) {
                    let obj = (res.result || []).slice(0, 6)
                    obj = obj.map((item, index) => {
                        return {
                            name: item.name,
                            active: false,
                            id: item.id
                        }
                    })
                    this.defaultAllergy = [].concat(obj)
                    // this.allergyList.forEach(item => {
                    //   obj.unshift(item)
                    // })
                    // console.log(obj,1213123)
                    this.allergyList = obj
                    this.allergyListLength = obj.length
                }
            } catch (error) { }
        },
        /**
         * @description: 初始化宜块钱问诊诊断字段
         * @param {type}
         * @return:
         */
        initDiagnose (detail, allergyStr, type, value) {
            // 初始化诊断
            if (detail.diagnosis && detail.diagnosisCode) {
                let list = []
                const arr = detail.diagnosis ? detail.diagnosis.split('|') : []
                const diseaseCooesArr = detail.diagnosisCode
                    ? detail.diagnosisCode.split('|')
                    : []
                diseaseCooesArr.forEach((v, i) => {
                    list.push({
                        diagnosisCode: v,
                        diagnosisName: arr[i],
                        active: true,
                        diagnosisType: '1'
                    })
                })
                this.diacrisis = detail.diagnosis
                this.diseaseCooes = diseaseCooesArr.join('|')
                // todo 输入姓名时 需要过滤诊断 不需要了this.selectedList = list
                this.selectedList = list
            }
            //将缓存的字符串转化为病情描述对象
            if (detail.mainSuit.length !== 0) {
                this.tips = []
                this.tips = [].concat(this.defaultMainSuit)
                let cacheTips = detail.mainSuit.trim().split(' ')
                // 去掉空格项
                for (let i = 0; i < cacheTips.length; i++) {
                    if (cacheTips[i].trim().length === 0) {
                        cacheTips.splice(i, 1)
                        i--
                    }
                }
                cacheTips = cacheTips.map(item => {
                    return {
                        mainSuitName: item,
                        active: true
                    }
                })
                if (this.tips.length === 0) {
                    this.tips = cacheTips
                } else {
                    this.tips.forEach(item => {
                        item.active = false
                    })
                    // 主诉数据去重
                    cacheTips.forEach(cacheTip => {
                        for (let i = 0; i < this.tips.length; i++) {
                            if (cacheTip.mainSuitName === this.tips[i].mainSuitName) {
                                this.tips.splice(i, 1)
                                i--
                            }
                        }
                    })
                    //去掉非默认病情描述
                    for (let i = 0; i < this.tips.length; i++) {
                        if (!this.tips[i].default) {
                            this.tips.splice(i, 1)
                            i--
                        }
                    }
                    // 主诉数据插入页面
                    cacheTips.forEach(item => {
                        this.tips.unshift(item)
                    })
                }
            } else {
                this.tips = []
                this.tips = [].concat(this.defaultMainSuit)
                for (let i = 0; i < this.tips.length; i++) {
                    this.tips[i].active = false
                }
            }

            // 初始化过敏史
            if (!value) { // 如果没有传递value值才执行这里 区别出带出上次药品
                this.allergyList = []
                this.allergyList = [].concat(this.defaultAllergy)
                if (type == 1) {
                    this.allergyList.forEach(item => {
                        // 如果没有过敏史，将卡片全部置灰
                        item.active = false
                    })
                } else if (type == 2) {
                    let cacheAllergy = []
                    if (allergyStr !== null && allergyStr !== '') {
                        cacheAllergy = allergyStr.trim().split(' ') // 将缓存的过敏史转化为对象
                        for (let i = 0; i < cacheAllergy.length; i++) {
                            // 去掉空格项
                            if (cacheAllergy[i].trim().length === 0) {
                                cacheAllergy.splice(i, 1)
                                i--
                            }
                        }
                    }

                    cacheAllergy = cacheAllergy.map((item, index) => {
                        return {
                            name: item,
                            active: true,
                            id: index + 9999
                        }
                    })
                    this.allergyList.forEach(item => {
                        item.active = false
                    })
                    cacheAllergy.forEach(item => {
                        for (let i = 0; i < this.allergyList.length; i++) {
                            if (item.name === this.allergyList[i].name) {
                                this.allergyList.splice(i, 1)
                                i--
                            }
                        }
                    })
                    cacheAllergy.forEach(item => {
                        // this.allergyList.unshift(item)
                        this.allergyList.push(item)
                    })
                }
            }
            this.medicineArr.length > 0 && this.getDiagnosisByMedicine()
            //重新计算主诉长度
            let num = 0
            this.tips.forEach(item => {
                if (item.active === true) {
                    num += item.mainSuitName.length
                }
            })
            this.mainSuitLen = num
        },
        /**
         * @description: 初始化宜块钱问诊诊断字段(中药)
         * @param {type}
         * @return:
         */
        initDiagnoseCn (detail, allergyStr, type, value) {
            // 初始化诊断
            // if (detail.diagnosis && detail.diagnosisCode) {
            //   let list = []
            //   const arr = detail.diagnosis ? detail.diagnosis.split('|') : []
            //   const diseaseCooesArr = detail.diagnosisCode
            //     ? detail.diagnosisCode.split('|')
            //     : []
            //   diseaseCooesArr.forEach((v, i) => {
            //     list.push({
            //       diagnosisCode: v,
            //       diagnosisName: arr[i],
            //       active:true,
            //       diagnosisType:'1'
            //     })
            //   })
            //   this.diacrisis = detail.diagnosis
            //   this.diseaseCooes = diseaseCooesArr.join('|')
            //   this.selectedList = list
            // }
            //将缓存的字符串转化为病情描述对象
            if (detail.mainSuit.length !== 0) {
                this.tips = []
                this.tips = [].concat(this.defaultMainSuit)
                let cacheTips = detail.mainSuit.trim().split(' ')
                // 去掉空格项
                for (let i = 0; i < cacheTips.length; i++) {
                    if (cacheTips[i].trim().length === 0) {
                        cacheTips.splice(i, 1)
                        i--
                    }
                }
                cacheTips = cacheTips.map(item => {
                    return {
                        mainSuitName: item,
                        active: true
                    }
                })
                if (this.tips.length === 0) {
                    this.tips = cacheTips
                } else {
                    this.tips.forEach(item => {
                        item.active = false
                    })
                    // 主诉数据去重
                    cacheTips.forEach(cacheTip => {
                        for (let i = 0; i < this.tips.length; i++) {
                            if (cacheTip.mainSuitName === this.tips[i].mainSuitName) {
                                this.tips.splice(i, 1)
                                i--
                            }
                        }
                    })
                    //去掉非默认病情描述
                    for (let i = 0; i < this.tips.length; i++) {
                        if (!this.tips[i].default) {
                            this.tips.splice(i, 1)
                            i--
                        }
                    }
                    // 主诉数据插入页面
                    cacheTips.forEach(item => {
                        this.tips.unshift(item)
                    })
                }
            } else {
                this.tips = []
                this.tips = [].concat(this.defaultMainSuit)
                for (let i = 0; i < this.tips.length; i++) {
                    this.tips[i].active = false
                }
            }
            // 初始化过敏史
            if (!value) { // 只有不是从 上次药品调用的才会执行这里
                this.allergyList = []
                this.allergyList = [].concat(this.defaultAllergy)
                if (type == 1) {
                    this.allergyList.forEach(item => {
                        // 如果没有过敏史，将卡片全部置灰
                        item.active = false
                    })
                } else if (type == 2) {
                    let cacheAllergy = []
                    if (allergyStr !== null && allergyStr !== '') {
                        cacheAllergy = allergyStr.trim().split(' ') // 将缓存的过敏史转化为对象
                        for (let i = 0; i < cacheAllergy.length; i++) {
                            // 去掉空格项
                            if (cacheAllergy[i].trim().length === 0) {
                                cacheAllergy.splice(i, 1)
                                i--
                            }
                        }
                    }

                    cacheAllergy = cacheAllergy.map((item, index) => {
                        return {
                            name: item,
                            active: true,
                            id: index + 9999
                        }
                    })
                    this.allergyList.forEach(item => {
                        item.active = false
                    })
                    cacheAllergy.forEach(item => {
                        for (let i = 0; i < this.allergyList.length; i++) {
                            if (item.name === this.allergyList[i].name) {
                                this.allergyList.splice(i, 1)
                                i--
                            }
                        }
                    })
                    cacheAllergy.forEach(item => {
                        // this.allergyList.unshift(item)
                        this.allergyList.push(item)
                    })
                }
            }
            this.medicineArr.length > 0 && this.getDiagnosisByMedicine()
            //重新计算主诉长度
            let num = 0
            this.tips.forEach(item => {
                if (item.active === true) {
                    num += item.mainSuitName.length
                }
            })
            this.mainSuitLen = num
        },
        /**
         * @description: 完成诊断，将诊断数组转成字符串
         * @param {Array} 诊断数组
         * @return: void
         */
        confirmDiacrisis (list) {
            let obj =
                this.formItem.medicineType == 0
                    ? this.selectedList
                    : this.selectedListCn
            let diagnosis =
                this.formItem.medicineType == 0 ? this.diagnosis : this.diagnosisCn
            let diagnosisCode =
                this.formItem.medicineType == 0
                    ? this.diagnosisCode
                    : this.diagnosisCodeCn
            if (this.formItem.medicineType == 0) {
                this.remarkFlag = false
            } else {
                this.remarkFlagCn = false
            }
            if (list.length !== 0) {
                const arr = []
                const diseaseCooesArr = []
                list.forEach(v => {
                    arr.push(v.diagnosisName)
                    diseaseCooesArr.push(v.diagnosisCode)
                })
                diagnosis = arr.join('|')
                diagnosisCode = diseaseCooesArr.join('|')

                obj.forEach(item => {
                    const index = list.findIndex(el => {
                        return el.diagnosisName === item.diagnosisName
                    })
                    if (index === -1) {
                        item.active = false
                    }
                })
                list.forEach(item => {
                    const index = obj.findIndex(el => {
                        return el.diagnosisName === item.diagnosisName
                    })
                    if (index === -1) {
                        // 如果没有
                        obj.push(item)
                    } else if (!obj[index].active) {
                        obj[index].active = item.active
                    }
                })
            } else {
                diagnosis = ''
                diagnosisCode = ''
                obj.forEach(el => {
                    el.active = false
                })
            }
        },
        /**
         * @description: 切换问诊类型
         * @param {Number}
         * @return:
         */
        onToggleInquiryType (type) {
            this.formItem.inquiryType = type
        },
        // 是否复诊
        diagnosedChnaged () {
            if (this.isDiagnose === '2') {
                this.fileList = [];
                this.checkImageList = [];
                this.cancelDiagnosed()
            }
        },
        cancelDiagnosed () {
            this.$dialog.alert({
                title: '提示',
                message:
                    '根据国家互联网医院管理办法，平台仅为复诊患者提供服务，本次无法发起问诊'
            })
        },
        closeProtocol () {
            this.pageVisible = false
        },
        /**
         * @description: 显示协议
         * @param: {number} 协议编号
         * @return: void
         */
        showAgreement (agreementNum) {
            this.pageVisible = true
            this.agreementTitle =
                agreementNum === 3 ? '宜贰叁互联网医院服务协议' : '问诊知情同意书'
        },

        /**
         * @description:关闭新增页面
         * @return: void
         */
        closeAdd () {
            this.showAdd = false
        },
        /**
         * @description:跳转新增药品
         * @return: void
         */
        toNewMedicine () {
            this.showAdd = true
            let flag = ''
            if (this.step === 1) {
                // 搜索药品页
                flag = 'add_information_newmedicine_shop_app'
            } else {
                // 填写信息页
                flag = 'add_newmedicine_shop_app'
            }
            window.webSdk.track(flag, {
                organSign: getCookie('native_organSign'),
                drugstoreName: getCookie('native_drugstoreName') || ''
            })
        },
        /**
         * @description:修改单个药品信息
         * @param: {Object} data 药品信息
         * @return: void
         */
        async editMedicine (data) {
            this.medicineArr.push(data)
            const params = {
                organSign: getCookie('native_organSign'),
                type: data.type,
                pref: data.pref,
                useFrequency: data.useFrequency,
                singleDose: data.singleDose,
                singleUnit: data.singleUnit,
                directions: data.directions
            }
            try {
                const res = await updateMedicine(params)
            } catch (err) {
                console.log(err.msg)
            }
            this.handleData()
        },
        cacheInfo () {
            if (!localStorage.getItem('params')) {
                return false
            }
            const obj = JSON.parse(localStorage.getItem('params'))
            this.formItem.inquiryType = obj.inquiryType
            this.formItem.name = obj.userName
            this.formItem.phoneNum = obj.telephone
            this.formItem.customAge = obj.customAge
            this.idNum = obj.idCard
            this.formItem.sex = obj.sex.toString()
            this.formItem.medicineType =
                obj.medicineType === undefined ? '0' : obj.medicineType.toString()
            this.hasAllergy = obj.allergySymptom.toString()
            this.allergySymptomExplain = obj.allergySymptomExplain || ''
            this.pregnancyAndLactation = obj.pregnancyAndLactation.toString()
            this.liverAndRenalFunction = obj.liverAndRenalFunction.toString()
            this.patientGuid = obj.guid
            this.organSign = localStorage.getItem('organSign')
            if (obj.lastDiagnosis) {
                if (obj.medicineType == 0) {
                    // 西药
                    this.isDiagnose = obj.lastDiagnosis.offlineDiagnosis.toString()
                    this.checkImageList = obj.lastDiagnosis.checkImageList
                    this.chronicRequire = obj.lastDiagnosis.chronicRequire
                    this.mainSuit = obj.lastDiagnosis.mainSuit
                    this.diagnosis = obj.lastDiagnosis.diagnosis
                    this.diagnosisCode = obj.lastDiagnosis.diagnosisCode
                    const mObj = obj.lastDiagnosis.prescriptionDetail
                    this.medicineArr = mObj
                    mObj.map(item => {
                        item.num = parseInt(item.quantity)
                    })
                    obj.allergySymptomExplain = Array.from(new Set(obj.allergySymptomExplain.trim().split(" "))).join(" ");
                    this.initDiagnose(
                        obj.lastDiagnosis,
                        obj.allergySymptomExplain,
                        obj.allergySymptom
                    ) // 处理西药诊断
                    if(obj.allergySymptomExplain.length) {
                        this.hasAllergy = '2'
                    }
                } else {
                    // 中药
                    this.isDiagnose = obj.lastDiagnosis.offlineDiagnosis.toString()
                    this.checkImageList = obj.lastDiagnosis.checkImageList
                    this.chronicRequire = obj.lastDiagnosis.chronicRequire
                    this.mainSuit = obj.lastDiagnosis.mainSuit
                    this.diagnosis = obj.lastDiagnosis.diagnosis
                    this.diagnosisCode = obj.lastDiagnosis.diagnosisCode
                    let diagnosisCodeArr = this.diagnosisCode
                        ? this.diagnosisCode.split('|')
                        : ''
                    if (this.diagnosis) {
                        this.selectedListCn = this.diagnosis
                            .split('|')
                            .map((item, index) => {
                                return {
                                    active: true,
                                    diagnosisCode: diagnosisCodeArr[index],
                                    diagnosisName: item,
                                    diagnosisType: 1
                                }
                            })
                    }
                    const mObj = obj.lastDiagnosis.prescriptionTCMDetail
                    this.medicineArrCn = mObj
                    this.medicineParamsCn = obj.lastDiagnosis.dosageAndUsage
                    obj.allergySymptomExplain = Array.from(new Set(obj.allergySymptomExplain.trim().split(" "))).join(" ");
                    this.initDiagnoseCn(
                        obj.lastDiagnosis,
                        obj.allergySymptomExplain,
                        obj.allergySymptom
                    )
                    if(obj.allergySymptomExplain.length) {
                        this.hasAllergy = '2'
                    }
                }
            }
        },

        fnback () {
            this.step = 0
        },
        idCardInput () {
            let type = "input"
            let idNum = this.idNum;
            // 有身份证号则转大写
            if (idNum) {
                idNum = idNum.toUpperCase();
            }

            if (idNum && !this.checkIDCard(idNum) && type) {

                return false
            } else if (idNum && this.checkIDCard(idNum)) {
                let age = this.getAgeByIdNO(idNum);
                this.formItem.sex = this.getSexByIdNO(idNum)
                this.formItem.customAge = this.getAgeByIdNO(idNum)
                if (age >= 0 && age <= 150) {

                    return true
                } else {
                    this.$toast({
                        message: '支持年龄输入范围1-150岁'
                    })
                    return false
                }

            }
        },
        // 身份证号验证结果
        idCardValid (type) {
            let idNum = this.idNum;
            // 有身份证号则转大写
            if (idNum) {
                idNum = idNum.toUpperCase();
            }

            if (idNum && !this.checkIDCard(idNum) && type) {
                this.$toast({
                    message: '身份证号不合法'
                })
                return false
            } else if (idNum && this.checkIDCard(idNum)) {
                let age = this.getAgeByIdNO(idNum);
                this.formItem.sex = this.getSexByIdNO(idNum)
                this.formItem.customAge = this.getAgeByIdNO(idNum)
                if (age >= 0 && age <= 150) {


                } else {
                    this.$toast({
                        message: '支持年龄输入范围1-150岁'
                    })
                    return false
                }

            }
        },
            // 身份证号验证方法
        checkIDCard (idcode) {
            if (!idcode) {
                return false
            }
             if(idcode.length == 18){//港澳台身份证校验
                let startNums = ['810000','820000','830000'];
                if(startNums.includes(idcode.substring(0,6))) return true;
             }
            // 加权因子
            const weight_factor = [
                7,
                9,
                10,
                5,
                8,
                4,
                2,
                1,
                6,
                3,
                7,
                9,
                10,
                5,
                8,
                4,
                2
            ]
            // 校验码
            const check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

            const code = idcode + ''
            const last = idcode[17] // 最后一位

            const seventeen = code.substring(0, 17)

            // ISO 7064:1983.MOD 11-2
            // 判断最后一位校验码是否正确
            const arr = seventeen.split('')
            const len = arr.length
            let num = 0
            for (let i = 0; i < len; i++) {
                num = num + arr[i] * weight_factor[i]
            }

            // 获取余数
            const resisue = num % 11
            const last_no = check_code[resisue]
            //lwq
            const idcard_patter = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;

            // 判断格式是否正确
            const format = idcard_patter.test(idcode)

            // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
            return !!(last === last_no && format)
        },
        handlerParams (params) {
            const result = {}
            for (var key in params) {
                result[key] = params[key]
            }
            //lwq
            result.lastDiagnosis.pregnancyAndLactationValue = pregnancyAndLactationSelect == null ? "''" : Number(pregnancyAndLactationSelect)
            result.lastDiagnosis.liverAndRenalFunctionValue = liverAndRenalFunctionSelect == null ? "''" : Number(liverAndRenalFunctionSelect)
            result.lastDiagnosis.birthday = birthday == null ? "''" : birthday
            result.lastDiagnosis = JSON.stringify(result.lastDiagnosis)
            if (this.$route.query.thirdPartyPrePrescriptionId != null && this.$route.query.thirdPartyPrePrescriptionId != undefined) {
                result.thirdPartyPrePrescriptionId = this.$route.query.thirdPartyPrePrescriptionId
            }return result
        },
        getInquiryAreaRuleByOrganSign (data) {
            let gtAge = data.gtAge
            let ltAge = data.ltAge
            let toInquiry = data.toInquiry
            let message
            let age = ''
            let flagStatus = false
            this.idNum ? age = this.getAgeByIdNO(this.idNum) : age = this.formItem.customAge
            if(this.isNewIM && toInquiry == 2) {
                if (age < ltAge && ltAge) {
                    message = `根据合规要求，${ltAge}岁以下患者禁止发起问诊，需前往线下医疗机构就诊`
                    flagStatus = true
                } else if (age >= gtAge && gtAge) {
                    message = `根据合规要求，${gtAge}岁以上患者禁止发起问诊，需前往线下医疗机构就诊`
                    flagStatus = true
                }
                if(this.formItem.inquiryType == 0 && this.pregnancyAndLactation == '1' && this.formItem.sex == '2') { // 视频问诊 需要特判
                    if (age < ltAge && ltAge) {
                        message = `根据合规要求，${ltAge}岁以下患者以及孕妇禁止发起问诊，需前往线下医疗机构就诊`
                        flagStatus = true
                    } else if (age >= gtAge && gtAge) {
                        message = `根据合规要求，${gtAge}岁以上患者以及孕妇禁止发起问诊，需前往线下医疗机构就诊`
                        flagStatus = true
                    } else {
                        message = '根据合规要求，孕产妇患者禁止线上问诊，需前往线下医疗机构就诊'
                        flagStatus = true
                    }
                }
            }else {
                if (toInquiry == 2 && this.pregnancyAndLactation == '1' && this.formItem.sex == '2') {
                    if (age < ltAge && ltAge) {
                        message = `根据合规要求，${ltAge}岁以下患者以及孕妇禁止发起问诊，需前往线下医疗机构就诊`
                        flagStatus = true
                    } else if (age >= gtAge && gtAge) {
                        message = `根据合规要求，${gtAge}岁以上患者以及孕妇禁止发起问诊，需前往线下医疗机构就诊`
                        flagStatus = true
                    } else {
                        message = '根据合规要求，孕产妇患者禁止线上问诊，需前往线下医疗机构就诊'
                        flagStatus = true
                    }
                } else {
                    if (age < ltAge && ltAge) {
                        message = `根据合规要求，${ltAge}岁以下患者禁止发起问诊，需前往线下医疗机构就诊`
                        flagStatus = true
                    } else if (age >= gtAge && gtAge) {
                        message = `根据合规要求，${gtAge}岁以上患者禁止发起问诊，需前往线下医疗机构就诊`
                        flagStatus = true
                    }
                }
            }

            if (flagStatus) {
                Dialog.confirm({
                    title: '提示',
                    message: message,
                    confirmButtonText: "我知道了",
                    confirmButtonColor: "#01b956",
                    showCancelButton: false,
                    width: "300px"
                })
                    .then(() => {
                        console.log('confirm')
                    })
                    .catch(() => {
                        console.log('cancel')
                    })
            }
            return flagStatus
        },
        // 根据门店organSign获取问诊规则
        async getInquiryAreaRuleBefore () {

            //  console.log(1)
            // let getParamsData = this.getParams();
            // let params = getParamsData.params;
            // console.log(params)
            try {
                this.isShowLoading = true
                const params = {
                    param: getCookie('native_organSign'),
                }
                const res = await getInquiryAreaRuleByOrganSign(params)
                if (res.data.code == 0) {
                    this.inquiryAreaRule = res.data.result
                    this.toPrescription();
                }
            } catch (err) {
                console.log(err & err.msg)
                this.isShowLoading = false;
            }
        },
        /**
         * @description: 点去问诊，检验表单，并调视频或跳im问诊
         * @return: void
         */
        toPrescription (e) {
            console.error(e)
            this.isShowLoading = true
            // 检查表单是否可提交，true-可提交,false-不可提交
            const isSubmit = this.checkedSubmit()
            if (isSubmit) {
                this.setLog({
                    message: '点击去开方',
                    type: '/interrogationInfoText'
                })
                if (this.getInquiryAreaRuleByOrganSign(this.inquiryAreaRule)) {
                    this.isShowLoading = false
                    return
                }
                // 去掉num
                if (!canSubmit) {
                    this.isShowLoading = false
                    return false
                }
                let getParamsData = this.getParams();
                let params = getParamsData.params;
                //处理含麻字段
                //************************
                let containEphedrine = false
                if (params.lastDiagnosis) {
                    let medicineDetailArr = params.lastDiagnosis.prescriptionDetail
                    console.log("medicineDetailArr", medicineDetailArr)
                    if (medicineDetailArr) {
                        if (medicineDetailArr.length) {
                            medicineDetailArr.forEach((item, index) => {
                                if (item.containEphedrine) {
                                    containEphedrine = true
                                }
                            })
                        }
                    }
                }
                if (containEphedrine && !params.idCard) {
                    Dialog.confirm({
                        title: '提示',
                        message: '预购药品中，存在含麻黄碱类复方制剂，请填写身份证信息',
                        confirmButtonText: "我知道了",
                        confirmButtonColor: "#01b956",
                        showCancelButton: false,
                        width: "300px"
                    })
                        .then(() => {
                            console.log('confirm')
                        })
                        .catch(() => {
                            console.log('cancel')
                        })
                    this.isShowLoading = false
                } else {

                    canSubmit = false
                    if (this.formItem.inquiryType === 1) {
                        // 图文问诊
                        this.goInquiry('tuwen')
                    } else {
                        // 视频问诊
                        window.location.href = `protocol://action/prepare_app_trtc`
                        // this.goInquiry()
                    }
                }
            }
        },
        /**
         *
         */
        testidNum (id) {
            //   if (!id) return true; // 空值默认合法
            if(!this.idCardMandatorySwitch){//为false时不做校验
                return true;
            }
             if (!id) return false;
            // 逻辑就是前6位是810000,820000,830000 , 然后总和是18位 港澳台规则
             if(id.length == 18){
                let startNums = ['810000','820000','830000'];
                if(startNums.includes(id.substring(0,6))) return true;
             }
            // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
            // var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
            // var format =/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9xX])$/;
            var format = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
            let age = this.getAgeByIdNO(id);
            if (age >= 0 && age <= 150) {

            } else {

                this.$toast({
                    message: '身份证格式不正确请重新输入'
                })
                return false
            }
            //号码规则校验
            if (!format.test(id)) {
                return false;
            }
            //区位码校验
            //出生年月日校验  前正则限制起始年份为1900;
            var year = id.substr(6, 4), //身份证年
                month = id.substr(10, 2), //身份证月
                date = id.substr(12, 2), //身份证日
                time = Date.parse(month + "-" + date + "-" + year), //身份证日期时间戳date
                now_time = Date.parse(new Date()), //当前时间戳
                dates = new Date(year, month, 0).getDate(); //身份证当月天数
            if (time > now_time || date > dates) {
                return false;
            }
            //校验码判断
            var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //系数
            var b = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"); //校验码对照表
            var id_array = id.split("");
            var sum = 0;
            for (var k = 0; k < 17; k++) {
                sum += parseInt(id_array[k]) * parseInt(c[k]);
            }
            if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
                return false;
            }

            return true;
        },
        /**
         * @description: 校验提交表单
         * @param {}
         * @return: boolean true - 可提交，false - 不可提交
         */
        checkedSubmit () {
            let submitFlag = true
            let submitMsg = ''
            if (this.formItem.name.length < 2) {
                submitFlag = false
                submitMsg = '姓名长度要求2-20字'
            }
            if (this.formItem.name.length > 20) {
                submitFlag = false
                submitMsg = '姓名长度要求2-20字'
            }
            if (submitFlag && this.formItem.phoneNum.length === 0) {
                submitFlag = false
                submitMsg = '手机号不能为空'
            }
            if (submitFlag && this.formItem.phoneNum.length !== 11) {
                submitFlag = false
                submitMsg = '手机号不正确'
            }
            if (submitFlag && !this.testidNum(this.idNum)) { // 身份证不对，直接拦截
                submitFlag = false
                submitMsg = '身份证号不合法'
            }

            if(this.containOverallPlanType) {
                const item = this.overallPlanTypeMap.find(item => item.label === this.overallPlanTypeText)

                if(!item) {
                    submitFlag = false
                    submitMsg = '请选择处方统筹类型'
                }
            }
            // const customAge =
            //   this.formItem.customAge && parseInt(this.formItem.customAge)
            // if (submitFlag && (customAge < 0 || customAge > 999)&&!this.testidNum(this.idNum)) {
            //   submitFlag = false
            //   submitMsg = '请输入正确年龄'
            // }
            // if(submitFlag&&this.analyzeIDCard(this.idNum)!=customAge&&this.idNum!=""){
            //   submitFlag = false
            //   submitMsg = '请输入正确年龄'
            // }
            // if (submitFlag && (customAge < 1 || customAge > 999)&&this.idNum=="") {
            //   submitFlag = false
            //   submitMsg = '请输入正确年龄'
            // }
            const customAge =
                this.formItem.customAge && parseInt(this.formItem.customAge)
            if (submitFlag && (customAge < 1 || customAge > 999)) {
                submitFlag = false
                submitMsg = '请输入正确年龄'
            }
            if (submitFlag && !this.formItem.sex) {
                submitFlag = false
                submitMsg = '性别不可以为空'
            }
            if (
                submitFlag &&
                this.formItem.medicineType == 0 &&
                !this.medicineArr.length
                && this.showPreDrug
            ) {
                submitFlag = false
                submitMsg = '请选择预购药品'
            }
            if (
                submitFlag &&
                this.formItem.medicineType == 1 &&
                !this.medicineArrCn.length
                && this.showPreDrug
            ) {
                submitFlag = false
                submitMsg = '请选择预购药品'
            }
            if (
                submitFlag &&
                this.formItem.medicineType == 1 &&
                this.medicineArrCn.length &&
                !this.medicineParamsCn.tcmTotalDosage
                && this.showPreDrug
            ) {
                submitFlag = false
                submitMsg = '请输入药品剂数'
            }
            //西药诊断校验
            if (this.formItem.medicineType == 0) {
                const index = this.selectedList.findIndex(item => {
                    return item.active === true
                })
                if (submitFlag && index === -1) {
                    submitFlag = false
                    submitMsg = '诊断不能为空'
                }
            }
            //中药诊断校验
            if (this.formItem.medicineType == 1) {
                const index = this.selectedListCn.findIndex(item => {
                    return item.active === true
                })
                if (submitFlag && index === -1) {
                    submitFlag = false
                    submitMsg = '诊断不能为空'
                }
            }
            if (
                submitFlag &&
                this.hasAllergy === '2' &&
                this.allergySymptomExplain.trim().length === 0
            ) {
                submitFlag = false
                submitMsg = '过敏史不能为空'
            }
            // 是否复诊
            if (submitFlag && this.isDiagnose === '2') {
                this.isShowLoading = false
                submitFlag = false
                this.cancelDiagnosed()
                return false
            }
            if (submitFlag && !this.agreeFlag) {
                submitFlag = false
                submitMsg = '请勾选协议'
            }
            if (!submitFlag) {
                this.$toast({
                    message: submitMsg,
                    duration: 1500
                })
                this.isShowLoading = false
                return false
            }
            return true
        },
        // setLocalParams() {
        //   const paramsMedicine = JSON.parse(JSON.stringify(this.medicineArr))
        //   paramsMedicine.map(item => {
        //     item.quantity = item.num || 1
        //     delete item.num
        //   })
        //   const params = {
        //     roomNumber: this.roomNumber,
        //     patientGuid: this.patientGuid,
        //     inquiryType: this.formItem.inquiryType,
        //     userName: this.formItem.name,
        //     telephone: this.formItem.phoneNum,
        //     idCard: this.idNum,
        //     sex: this.formItem.sex,
        //     customAge: this.formItem.customAge,
        //     allergySymptom: this.hasAllergy,
        //     allergySymptomExplain: this.allergySymptomExplain,
        //     pregnancyAndLactation: this.pregnancyAndLactation,
        //     liverAndRenalFunction: this.liverAndRenalFunction,
        //     lastDiagnosis: {
        //       mainSuit: this.mainSuit,
        //       offlineDiagnosis: this.isDiagnose,
        //       prescriptionDetail: paramsMedicine,
        //       diagnosis: this.diagnosis,
        //       diagnosisCode: this.diagnosisCode,
        //       selectedList: this.selectedList
        //     }
        //   }
        //   localStorage.setItem('params', JSON.stringify(params))
        // },
        prepareParams (medicines, medicineType) {
            let diagnosis = []
            let diagnosisCode = []
            let goalObj = medicineType == 0 ? this.selectedList : this.selectedListCn // 高亮的诊断对象
            goalObj.forEach(item => {
                if (item.active === true) {
                    diagnosis.push(item.diagnosisName)
                }
            })
            goalObj.forEach(item => {
                if (item.active === true) {
                    diagnosisCode.push(item.diagnosisCode)
                }
            })
            let mainSuit = this.tips.map(item => {
                if (item.active) {
                    return item.mainSuitName
                }
            })
            for (let i = 0; i < mainSuit.length; i++) {
                if (!mainSuit[i]) {
                    mainSuit.splice(i, 1)
                    i--
                }
            }
            let obj
            if (medicineType == 0) {
                // 西药类型
                obj = {
                    roomNumber: this.roomNumber,
                    patientGuid: this.patientGuid,
                    inquiryType: this.formItem.inquiryType,
                    userName: this.formItem.name,
                    telephone: this.formItem.phoneNum,
                    idCard: this.idNum,
                    sex: this.formItem.sex,
                    customAge: this.formItem.customAge,
                    medicineType: this.formItem.medicineType,
                    allergySymptom: this.hasAllergy,
                    allergySymptomExplain: this.allergySymptomExplain,
                    pregnancyAndLactation: parseInt(this.pregnancyAndLactation),
                    liverAndRenalFunction: parseInt(this.liverAndRenalFunction),
                    lastDiagnosis: {
                        mainSuit: mainSuit.join(' ').trim(),
                        offlineDiagnosis: this.isDiagnose,
                        chronicRequire: this.chronicRequire,
                        prescriptionDetail: medicines,
                        diagnosis: diagnosis.join('|'),
                        diagnosisCode: diagnosisCode.join('|'),
                        checkImageList: this.checkImageList,
                    }
                }
            } else {
                // 中药类型
                obj = {
                    roomNumber: this.roomNumber,
                    patientGuid: this.patientGuid,
                    inquiryType: this.formItem.inquiryType,
                    userName: this.formItem.name,
                    telephone: this.formItem.phoneNum,
                    idCard: this.idNum,
                    sex: this.formItem.sex,
                    customAge: this.formItem.customAge,
                    medicineType: this.formItem.medicineType,
                    allergySymptom: this.hasAllergy,
                    allergySymptomExplain: this.allergySymptomExplain,
                    pregnancyAndLactation: parseInt(this.pregnancyAndLactation),
                    liverAndRenalFunction: parseInt(this.liverAndRenalFunction),
                    lastDiagnosis: {
                        mainSuit: mainSuit.join(' ').trim(),
                        offlineDiagnosis: this.isDiagnose,
                        chronicRequire: this.chronicRequire,
                        prescriptionTCMDetail: medicines,
                        diagnosis: diagnosis.join('|'),
                        diagnosisCode: diagnosisCode.join('|'),
                        checkImageList: this.checkImageList,
                        dosageAndUsage: {
                            tcmTotalDosage: this.$refs.tcmList.dosageAndUsage.tcmTotalDosage, // 总副数
                            tcmDailyDosage: this.$refs.tcmList.dosageAndUsage.tcmDailyDosage, // 每日副数
                            tcmDailyFrequency: this.$refs.tcmList.dosageAndUsage
                                .tcmDailyFrequency, // 每日频次
                            tcmUsage: this.$refs.tcmList.dosageAndUsage.tcmUsage,
                            tcmProcessingMethod: this.$refs.tcmList.dosageAndUsage
                                .tcmProcessingMethod
                        },
                        prescriptionDetail: []
                    }
                }
            }

            return obj
        },
        analyzeIDCard (IDCard) {
            var age = 0, yearBirth, monthBirth, dayBirth;
            //获取用户身份证号码
            var userCard = IDCard;
            //如果身份证号码为undefind则返回空
            if (!userCard) {
                return age;
            }
            var reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/; //验证身份证号码的正则
            if (reg.test(userCard)) {
                if (userCard.length == 15) {
                    var org_birthday = userCard.substring(6, 12);
                    //获取出生年月日
                    yearBirth = "19" + org_birthday.substring(0, 2);
                    monthBirth = org_birthday.substring(2, 4);
                    dayBirth = org_birthday.substring(4, 6);
                } else if (userCard.length == 18) {
                    //获取出生年月日
                    yearBirth = userCard.substring(6, 10);
                    monthBirth = userCard.substring(10, 12);
                    dayBirth = userCard.substring(12, 14);

                }
                //获取当前年月日并计算年龄
                var myDate = new Date();
                var monthNow = myDate.getMonth() + 1;
                var dayNow = myDate.getDate();
                var age = myDate.getFullYear() - yearBirth;
                if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
                    age--;
                }
                //返回年龄
                return age;
            } else {
                return ''
            }

        },

    getParams(){

      let paramsMedicine
      if (this.formItem.medicineType == 0) {
        paramsMedicine = JSON.parse(JSON.stringify(this.medicineArr))
        paramsMedicine.forEach(item => {
          item.quantity = item.num || 1
          delete item.num
        })
      } else {
        paramsMedicine = JSON.parse(JSON.stringify(this.medicineArrCn))
      }
      let medicines = paramsMedicine.map(item => {
        // item.quantity = Math.floor(item.quantity*1000)/1000
        item.quantity = item.quantity
        return item
      })
      // 判断是中药类型还是西药类型，西药类型不传中药字段，中药类型把西药字段置空
      let params = this.prepareParams(medicines, this.formItem.medicineType) // 封装参数 //西药不变
      return {
        params,
        medicines
      }
    },
    goInquiry(type) {
      let getParamsData = this.getParams();
      //   添加统筹类型字段
      if(this.containOverallPlanType) {
            console.log("添加统筹类型字段");
            const item = this.overallPlanTypeMap.find(item  => item.label === this.overallPlanTypeText)
            console.log(item);
            
            if(item) {
                getParamsData.params.lastDiagnosis.overallPlanType = item.value
            } 
        }
      if(type==='tuwen' && this.isNewIM){
        // 缓存参数
        localStorage.setItem("newimParams", JSON.stringify(getParamsData));
        localStorage.setItem("selectedList", JSON.stringify(this.selectedList));
          this.isShowLoading = false;
        // 延迟2秒后跳转
        this.isAwaitDoctor = true;
        setTimeout(()=>{
          this.isAwaitDoctor = false;
          canSubmit = true;
          this.$router.push({ path: '/askDockerChat', query: { thirdPartyPrePrescriptionId: this.$route.query.thirdPartyPrePrescriptionId } })
        }, 2000)
        return;
      }
      let params = getParamsData.params;
      let medicines = getParamsData.medicines;
      getSign({})
        .then(data => {
          this.roomNumber = data.result.roomNumber
          const { employeeId, roomNumber, userSign } = data.result
          this.roomNumber = roomNumber
          this.employeeId = employeeId
          this.userSign = userSign
          // 表单参数
          const ids = {
            roomNumber,
            employeeId,
            userSign,
            imPlatform: getCookie('native_support_tim') || '0'
          }
          Object.assign(params, ids)
          const uploadParams = Object.assign({}, params, { lastDiagnosis: '' })
          this.setLog({
            message: `获取房间号成功,roomNumber: ${JSON.stringify(
              uploadParams
            )}`,
            type: '/interrogationInfoText'
          })
          this.setLog({
            message: `发起问诊预购药品medicineArr: ${JSON.stringify(medicines)}，房间号：${this.roomNumber}`,
            type: '/interrogationInfoText'
          })
            
            params.lastDiagnosis.prescriptionDetail.forEach((item)=>{
                item.singleDoseValue = item.singleDose
            })

           params.lastDiagnosis.teletextInquiryInteractionOptimizeSwitch = 0
           //todo4003
            patientInfoAndGotoInquir(this.handlerParams(params))
                .then(res => {
                  // 诊断埋点数据
                  const diagnoseList = this.selectedList.map((item, index) => {
                    return {
                      diagnosis_name: item.diagnosisName,
                      diagnosis_code: item.diagnosisCode,
                      diagnosis_type:
                          item.diagnosisType == 1
                              ? 0
                              : item.diagnosisType == 2
                              ? 1
                              : 2,
                      diagnosis_seq: index,
                      check: item.active
                    }
                  })
                  //诊断埋点
                  diagnoseList.forEach(item => {
                    window.webSdk.track('ds_page_diagnosis', item)
                  })
                  this.setLog({
                    message: `提交表单并问诊成功,roomNumber: ${JSON.stringify(
                        uploadParams
                    )}`,
                    type: '/interrogationInfoText'
                  })
                  params.patientGuid = res.patientGuid
                  this.$store.commit('setInquiryRecordGuid', res.inquiryReportGuid) // 问诊GUID
                  this.$store.commit('setRoomNumber', uploadParams.roomNumber)
                  this.$store.commit('setPatientGuid', res.patientGuid)
                  localStorage.setItem('params', JSON.stringify(params))
                  localStorage.setItem('organSign', this.organSign)
                  // 图文问诊
                  if (type === 'tuwen') {
                    const appUrl = `protocol://action/go_im_reception?inquiryId=${
                        res.inquiryReportGuid
                    }&roomNumber=${uploadParams.roomNumber}&patientGuid=${
                        res.patientGuid
                    }`
                    this.onH5GoInApp(appUrl)
                  } else {
                    // 视频问诊
                    this.$router.replace({
                      path: 'prescription',
                      query: {
                        ids: JSON.stringify(ids),
                        organSign: this.organSign,
                        inquiryReportGuid: res.inquiryReportGuid
                      }
                    })
                  }
                  canSubmit = true
                  this.isShowLoading = false
                  window.webSdk.track('click_to_prescription', {
                    organSign: getCookie('native_organSign'),
                    productPrefs: this.prefArr,
                    patientPhone: this.formItem.phoneNum
                  })
                })
                .catch((err) => {
                    if(err.code == 4003) {
                        this.isShowLoading = false
                        this.dialogShow = true ;
                         this.setLog({
                            message: '提交表单并问诊失败',
                            type: '/interrogationInfoText'
                        })
                        canSubmit = true
                        this.drugLimitDockerList = err.result.inquiryAntibacterialDrugDetailDtoList ;
                    }else {
                        this.$toast({
                            message: err.msg || err
                        })
                        this.isShowLoading = false
                        this.setLog({
                            message: '提交表单并问诊失败',
                            type: '/interrogationInfoText'
                        })
                        canSubmit = true
                    }
                })
                .finally(() => {})
          })
          .catch(err => {
            console.log(err)
            this.setLog({
              message: '获取房间号失败',
              type: '/interrogationInfoText'
            })
            canSubmit = true
            this.isShowLoading = false
          })
    },
    validateParams(obj) {
      if (obj.medicineType == 0 || obj.inquiryType == 0) {
        // 西药或视频时不校验
        return true
      }
      let flag = true
      obj.lastDiagnosis.prescriptionTCMDetail.forEach(item => {
        // 校验剂量
        if (item.quantity == 0) {
          this.$toast({
            message: '药品剂量不能为0！'
          })
          flag = false
          return false
        }
      })
      for (let v in obj.lastDiagnosis.dosageAndUsage) {
        if (obj.lastDiagnosis.dosageAndUsage[v] == 0) {
          this.$toast({
            message: '药品用法用量数值不能为0！'
          })
          flag = false
          return false
        }
      }
      return flag
    },
    finishMedicine(medicineArr) {
      let str = JSON.stringify(medicineArr);
      let obj = JSON.parse(str);
      this.medicineArr = obj
      this.setLog({
        message: `添加完成预购药品medicineArr: ${JSON.stringify(
            this.medicineArr
        )}`,
        type: '/interrogationInfoText'
      })
      this.step = 0
      this.title = '填写问诊人信息'
      let flag = false;
      this.medicineArr.forEach(res => {
        if (this.saveMediceArr.findIndex(k => k.pref === res.pref) == -1) {
          flag = true;
        }
      })
      this.saveMediceArr.forEach(res => {
        if (this.medicineArr.findIndex(k => k.pref === res.pref) == -1) {
          flag = true;
        }
      })
      if (flag) {
        if (this.formItem.medicineType == 0) {
          this.selectedList = [];
        } else {
          this.selectedListCn = [];
        }
        this.medicineArr.length && this.getDiagnosisByMedicine()
      }
    },
    closeMedicinePup() {
      this.showCart = false
    },
    updateCarList(index, data) {
      this.$set(this.medicineArr, index, data)
    },
    deleteNameItem (item) {
                Dialog.confirm({
                    title: '删除提示',
                    message: '确认删除该患者吗?',
                }).then(async () => {
                    try {
                        let res = await postUpdateIsNotShowStatus({guid:item.guid,isNotShow:1});
                        if (res.data.code == 0) {
                           this.$toast('删除成功')
                           this.formItem.name = '';
                        } else {
                            this.$toast(res.msg)
                        }
                    } catch (error) {

                    }
                })
                    .catch(() => {
                        // on cancel
                    });
            },
            getLastWomen(lastDiagnosisStrObj){ // 带出上一次的妊娠期、肝肾功能
                 let  liverAndRenalFunction = lastDiagnosisStrObj.liverAndRenalFunction;
                let  pregnancyAndLactation = lastDiagnosisStrObj.pregnancyAndLactation;

                let  liverAndRenalFunctionValue = lastDiagnosisStrObj.liverAndRenalFunctionValue
                let  pregnancyAndLactationValue = lastDiagnosisStrObj.pregnancyAndLactationValue
                debugger
                if(liverAndRenalFunction) {
                    if(liverAndRenalFunctionValue == 1) {
                        this.liverAndRenalFunctionSelect = [1]
                    }else if(liverAndRenalFunctionValue == 2) {
                        this.liverAndRenalFunctionSelect = [2]
                    }else {
                        this.liverAndRenalFunctionSelect = [1,2]
                    }
                }
                if(pregnancyAndLactation) {
                    this.pregnancyAndLactationSelect = pregnancyAndLactationValue
                }

            },
      async handlerNameList(index) {

    await this.getZWSwitch() ;
      const obj = this.nameList[index]
      // let lastDiagnosis = JSON.parse(obj.lastDiagnosis);
      //  lastDiagnosis.prescriptionDetail ---  药品信息
      //  lastDiagnosis.diagnosis ---  诊断信息
      console.log(obj,"---tjy")  ;
      //  ;
      this.formItem.name = obj.userName
      this.formItem.phoneNum = obj.telephone
      this.idNum = obj.idCard
      this.formItem.sex = obj.sex.toString()
      this.formItem.customAge =
        (obj.customAge && obj.customAge.toString()) || ''
      this.formItem.medicineType =
        obj.medicineType === undefined ? '0' : obj.medicineType.toString()
      this.hasAllergy = obj.allergySymptom.toString()
      this.allergySymptomExplain = obj.allergySymptomExplain || ''
      if(obj.allergySymptomExplain) { // 过敏史去重
        this.allergySymptomExplain = Array.from(new Set(obj.allergySymptomExplain.trim().split(" "))).join(" ");
      }
      this.hasAllergy = '1'
      this.pregnancyAndLactation = obj.pregnancyAndLactation.toString() || '0'
      this.liverAndRenalFunction = obj.liverAndRenalFunction.toString() || '0'
       const lastDiagnosisStrObj1 = JSON.parse(obj.lastDiagnosis)
      this.getLastWomen(lastDiagnosisStrObj1)
      this.patientGuid = obj.guid
      this.organSign = obj.organSign
      // 清空诊断
        this.diagnosis = [] ;
        this.diagnosisCode = "" ;
        this.selectedList  = [] ; // 西药诊断
        this.selectedListCn  = [] ; // 中药诊断
      // 处理西药
      if (obj.lastDiagnosis) {
        console.log(this.westernMedicineBring , this.chineseMedicineBring,"---tjy")

        if(obj.medicineType == 0) {
            // 对过敏史去重
          obj.allergySymptomExplain = Array.from(new Set(obj.allergySymptomExplain.trim().split(" "))).join(" ");
          this.initDiagnose(
            lastDiagnosisStrObj1,
            obj.allergySymptomExplain,
            obj.allergySymptom,
            0 // 1表示带出药品信息时不带出 诊断信息  0表示带出
          )
          if(obj.allergySymptomExplain.length) {
            this.hasAllergy = '2'
          }
        }else {
            obj.allergySymptomExplain = Array.from(new Set(obj.allergySymptomExplain.trim().split(" "))).join(" ");
            this.initDiagnoseCn(
                lastDiagnosisStrObj1,
                obj.allergySymptomExplain,
                obj.allergySymptom,
                0// 表示带出药品信息时不带出 诊断信息
            )
            if(obj.allergySymptomExplain.length) {
                this.hasAllergy = '2'
            }
        } // 带出中西药诊断
        if (obj.medicineType == 0 && this.westernMedicineBring) {
          // 西药
          const lastDiagnosisStrObj = JSON.parse(obj.lastDiagnosis)
          this.isDiagnose = lastDiagnosisStrObj.offlineDiagnosis.toString()
          this.mainSuit = lastDiagnosisStrObj.mainSuit
          this.diagnosis = lastDiagnosisStrObj.diagnosis
          this.diagnosisCode = lastDiagnosisStrObj.diagnosisCode
          this.listData = []
          const mObj = lastDiagnosisStrObj.prescriptionDetail
          mObj.forEach(item => {
            item.num = item.quantity
            if (!item.pref) {
              item.pref = item.productPref
            }
          })
          this.medicineArr = mObj
          this.medicineArrCn = []
          this.diagnosisCn = ''
          this.diagnosisCodeCn = ''
          this.selectedListCn = []

        } else if (obj.medicineType == 1 && this.chineseMedicineBring){
          // 处理中药
          const lastDiagnosisStrObj = JSON.parse(obj.lastDiagnosis)
          this.isDiagnose = lastDiagnosisStrObj.offlineDiagnosis.toString()
          this.mainSuit = lastDiagnosisStrObj.mainSuit
          if (
            lastDiagnosisStrObj.diagnosis &&
            lastDiagnosisStrObj.diagnosisCode
          ) {
            this.diagnosis = lastDiagnosisStrObj.diagnosis
            this.diagnosisCode = lastDiagnosisStrObj.diagnosisCode
            let diagnosisCodeArr = this.diagnosisCode
              ? this.diagnosisCode.split('|')
              : []
            this.selectedListCn = this.diagnosis
              .split('|')
              .map((item, index) => {
                return {
                  active: true,
                  diagnosisCode: diagnosisCodeArr[index],
                  diagnosisName: item,
                  diagnosisType: 1
                }
              })
          }
          const mObj = lastDiagnosisStrObj.prescriptionTCMDetail.map(item => {
            item.show = true
            return item
          })
          this.medicineArr = []
          this.selectedList = []
          this.medicineArrCn = mObj
          this.medicineParamsCn = lastDiagnosisStrObj.dosageAndUsage

          }else {
          this.diagnosis = [] ;
          this.medicineArr = [] ;
          this.selectedList  = [] ; // 西药诊断
          this.diagnosisCode = ""
          this.medicineArrCn = []
          this.medicineParamsCn = []
          this.selectedListCn  = [] ; // 中药诊断
        }
      }else {
        this.diagnosis = [] ;
        this.medicineArr = [] ;
        this.selectedListCn  = [] ;
        this.diagnosisCode = ""
      }
      //  获取到上次的病情信息   但是 病情描述不需要带出展示
      // this.tips = [] ;
      if(!this.westernMedicineBring && obj.medicineType == 0) {
        this.tips = []
      }
      if(!this.chineseMedicineBring && obj.medicineType == 1) {
        this.tips = []
      }
      this.showNameList = false
      console.log("-------------xa---------------");
      
    },
    analysisId(id) {
      if (this.idNum.length === 18) {
        this.formItem.sex = this.getSexByIdNO(id)
      } else {
        this.$toast({
          message: '请输入正确的身份证号'
        })
      }
    },
    inputName() {
      this.noticeText = noticeTextArr[1]
      if (this.formItem.name.length > 20) {
        this.formItem.name = this.formItem.name.slice(0, 20)
        this.$toast({
          message: '姓名字数2-20个字',
          duration: 1500
        })
      }
      if (this.formItem.name === '') {
        // clearInterval(this.timer)
        this.showNameList = false
      }
      // 清除patientGuid
      this.patientGuid = ''
      this.searchQuery(this.formItem.name)
    },
    async searchQuery(val, callback) {
    if (this.isHaiDian) {
        return;
    }
      if (val) {
        const res = await searchPatientInfo({ userName: val, pageSize: 100 ,isNotShow:0})

        // console.log(res.list[0],"lwq")
        res.list.forEach(item=>{
        let type="input"
       let idNum = item.idCard;
          // // 有身份证号则转大写
           if (idNum) {
             idNum = idNum.toUpperCase();
           }

                    if (idNum && !this.checkIDCard(idNum) && type) {

                        return false
                    } else if (idNum && this.checkIDCard(idNum)) {
                        let age = this.getAgeByIdNO(idNum);
                        if (age >= 0 && age <= 150) {
                            //this.formItem.sex = this.getSexByIdNO(idNum)
                            if (item.patientUnifiedAag) {
                                item.patientUnifiedAag = this.getAgeByIdNO(idNum) + "岁"
                            } else if (item.age) {
                                item.age = this.getAgeByIdNO(idNum) + "岁"
                            }
                            console.log(item.patientUnifiedAag, item.age, 11111111111111)
                            item.customAge = this.getAgeByIdNO(idNum)
                            return true
                        } else {

                            return false
                        }
                    }
                })
                this.nameList = res.list
}
        },

        async getRemark () {
            const params = {
                mainSuitStatus: 1
            }
            try {
                let res = await getMainSuitList(params)
                res && (res = res.slice(0, 6))
                this.defaultMainSuit = [].concat(res)
                if (this.tips.length !== 0) {
                    this.tips.forEach(tip => {
                        // 接口返回值去重
                        for (let i = 0; i < res.length; i++) {
                            if (tip.mainSuitName === res[i].mainSuitName) {
                                res.splice(i, 1)
                                i--
                            }
                        }
                    })
                    res.forEach(item => {
                        // 将接口返回的病情描述插入页面
                        this.$set(item, 'active', false)
                        this.$set(item, 'default', true)
                        this.tips.push(item)
                    })
                } else {
                    res.forEach(item => {
                        this.$set(item, 'active', false)
                        this.$set(item, 'default', true)
                    })
                    this.tips = res
                }
            } catch (error) {
                console.error(error)
            }
        },
        toSearchMedicine () {
            console.log(this.formItem.medicineType, "药的类型");
            if (this.formItem.medicineType == 1) {
                // 展示中药搜索
                this.showSearchMedicineCn = true
                this.saveMediceArr = JSON.parse(JSON.stringify(this.medicineArrCn));
            } else {
                let str = JSON.stringify(this.medicineArr);
                this.medicineArrCopy = JSON.parse(str);
                this.saveMediceArr = JSON.parse(JSON.stringify(this.medicineArr));
            }
            this.step = 1
            this.title = '搜索预购药品'
            window.scrollTo(0, 0)
            if (!getCookie('native_organSign')) {
                return false
            }
            window.webSdk.track('add_medicine', {
                organSign: getCookie('native_organSign')
            })
        },
        onClickLeft () {
            if (this.step == 0) {
                this.$router.push('/home')
            } else {
                this.medicineArr.length > 0 && this.getDiagnosisByMedicine()
                this.step = 0
                this.title = '填写问诊人信息'
                // this.$nextTick(() => {
                //   window.scrollTo(10000, 10000)
                // })
            }
            // <van-radio name="0">西药</van-radio>
            //         <van-radio name="1">中药</van-radio>
            var mediceArr = [];
            if (this.formItem.medicineType == 1) {
                mediceArr = this.medicineArrCn;
            } else {
                mediceArr = this.medicineArr;
            }
            let flag = false;
            mediceArr.forEach(res => {
                if (this.saveMediceArr.findIndex(k => k.pref === res.pref) == -1) {
                    flag = true;
                }
            })
            this.saveMediceArr.forEach(res => {
                if (mediceArr.findIndex(k => k.pref === res.pref) == -1) {
                    flag = true;
                }
            })
            if (flag) {
                this.formItem.medicineType == 0
                    ? this.selectedList
                    : this.selectedListCn
                if (this.formItem.medicineType == 0) {
                    this.selectedList = [];
                } else {
                    this.selectedListCn = [];
                }
                this.getDiagnosisByMedicine()
            }
        },
        addMedicine (data) {
            if (this.medicineArr.length > 4) {
                this.$toast({
                    message: '最多添加5种药品',
                    duration: 2000
                })
                this.showAdd = false
                return false
            }
            this.$refs.westernMedicineChild.addMedicine(data)
            this.showAdd = false

        },
        /**
         * @description: 添加过敏史
         * @param {}
         * @return:
         */
        handleClickAllery (type, tips) {
            // 无过敏史，清空
            if (type === 'clear') {
                this.allergySymptomExplain = ''
                this.hasAllergy = '1'
                this.allergyList.forEach(item => {
                    item.active = false
                })
                this.allergyList.splice(this.allergyListLength)
                return false
            }
            this.hasAllergy = '2'
            if (!tips.active) {
                let len = 0
                this.allergyList.forEach(item => {
                    if (item.active) {
                        len += item.name.length
                    }
                })
                // if (len + tips.name.length > 50) {
                //   this.$toast({
                //     message: '过敏史不能超过50字符'
                //   })
                //   return false
                // }
                tips.active = true
                // this.allergyList.push(tips)
                this.allergySymptomExplain = (
                    this.allergySymptomExplain +
                    ' ' +
                    tips.name
                ).trim()
            } else {
                let index;
                for (let x = 0; x < this.allergyList.length; x++) {
                    if (this.allergyList[x].id == tips.id) {
                        index = x
                    }
                }
                // const index = this.allergyList.findIndex(item => {
                //   return item.id == tips.id
                // })
                console.log(tips, this.allergyListLength, this.allergyList, index)
                if (index >= this.allergyListLength) {

                    this.allergyList.splice(index, 1)
                } else {
                    this.allergyList[index].active = false
                    let str = ''
                    this.allergyList.forEach(item => {
                        if (item.active) {
                            str += ' ' + item.name
                        }
                    })
                    this.allergySymptomExplain = str.trim()
                }

            }
            let arr = this.allergyList.filter(item => {
                return item.active == true
            })

            if (arr.length == 0) {
                this.handleClickAllery("clear")
            }

        },
        // 根据身份证号获取生日
        getAgeByIdNO (IdNO) {
            let idInfo = {
                birthday: 0, // 生日 2020/09/21
                age: 0, // 年龄
            }

            let _birthday = '';
            if (IdNO.length == 18) {
                let _tempBirthday = IdNO.substr(6, 8);
                _birthday = _tempBirthday.replace(/(.{4})(.{2})/, '$1/$2/');
            } else if (IdNO.length == 15) {
                let _tempBirthday = '19' + IdNO.substr(6, 6)
                _birthday = _tempBirthday.replace(/(.{4})(.{2})/, '$1/$2/')
            }
            idInfo.birthday = _birthday;

            // 计算年龄
            let _age = 0;
            let year_temp = '';
            let months_temp = '';
            let days_temp = '';
            if (IdNO.length == 18) {
                year_temp = IdNO.substring(6, 10);// 截取身份证上的年
                months_temp = IdNO.substring(10, 12);//截取身份证上的月
                days_temp = IdNO.substring(12, 14);//截取身份证上的日
            } else if (IdNO.length == 15) {
                let strBirthday = "19" + IdNO.substr(6, 2) + IdNO.substr(8, 2) + IdNO.substr(10, 2);
                year_temp = strBirthday.substring(0, 4);// 截取身份证上的年
                months_temp = strBirthday.substring(4, 6);//截取身份证上的月
                days_temp = strBirthday.substring(6, 8);//截取身份证上的日
            }
            let myDate = new Date();
            let month = myDate.getMonth() + 1;
            let day = myDate.getDate();

      _age = myDate.getFullYear() - year_temp;
      // 计算是否过了今年的生日逻辑
      if (month < months_temp || (months_temp == month && day < days_temp)) {
        _age--
      }
      idInfo.age = _age;
      return idInfo.age.toString();
      // 原来的老逻辑
      // let age = ''
      // const curYear = new Date().getFullYear()
      // if (IdNO.length == 18) {
      //   age = IdNO.substr(6, 4)
      // } else if (IdNO.length == 15) {
      //   age = '19' + IdNO.substr(6, 2)
      // }
      // age = curYear - parseInt(age) + 1
      // return age.toString()
    },
    // 根据身份证号获取性别
    getSexByIdNO(IdNO) {
      if (IdNO.length == 18) {
        return IdNO.charAt(16) % 2 == 0 ? '2' : '1'
      } else if (IdNO.length == 15) {
        return IdNO.charAt(14) % 2 == 0 ? '2' : '1'
      } else {
        return ''
      }
    },
    /**
     * @description: 加log日志
     * @param {Object} json对象
     * @return:
     */
      setLog(msg) {
      $hyjkLoggerSdk.info(initLog(msg), "PATIENTH5");
    },
    //调整信息
    goBack(){
      this.allergyFlagShow=false
    },
    //继续提交
    next(){
      this.allergyFlagShow=false
    this.getInquiryAreaRuleBefore()
    },
    // 查询是否有问诊区域|门店规则
    async getInquiryAreaSwitch() {
            const { data = {} } = await checkInquiryConfig({organSign: getCookie('native_organSign')});
            if(data.code === 0 && data.result){
                const { teletextInquiryInteractionOptimizeSwitch,idCardMandatorySwitch} = data.result
                this.isNewIM = !!teletextInquiryInteractionOptimizeSwitch
                this.idCardMandatorySwitch = idCardMandatorySwitch;
              }
            },
    ageBlurChange () {
                if (this.idNum && this.checkIDCard(this.idNum.toUpperCase())) {
                    this.formItem.customAge = this.getAgeByIdNO(this.idNum)
                }
            },
            // 海典去添加
            haiDianAddConfirm () {
                if (this.formItem.medicineType == 1) {
                    // 展示中药搜索
                    this.showSearchMedicineCn = true
                    this.saveMediceArr = JSON.parse(JSON.stringify(this.medicineArrCn));
                    this.$refs.search.haiDianAutoWriteFun(this.showDrugWarningInfo[0]);
                } else {//西药
                    let str = JSON.stringify(this.medicineArr);
                    this.medicineArrCopy = JSON.parse(str);
                    this.saveMediceArr = JSON.parse(JSON.stringify(this.medicineArr));
                    this.$refs.westernMedicineChild.haiDianAutoWriteFun(this.showDrugWarningInfo[0]);
                }
                this.step = 1
                this.title = '搜索预购药品'
                window.scrollTo(0, 0)
            },
            // 海典问诊方法
            async checkHaidianFn () {
                try {
                    this.isShowLoading = true;
                    window.location.href = 'protocol://action/hideBottomTab'
                    let id = this.$route.query.thirdPartyPrePrescriptionId
                    this.formItem = {
                        inquiryType: this.formItem.inquiryType, // 1 - 图文问诊，0 - 视频问诊
                        name: '', // 名字
                        phoneNum: '', // 电话号
                        customAge: '', // 年龄
                        sex: '1', // 性别
                        medicineType: '0'
                    };
                    this.idNum = '';
                    this.medicineArr = [];
                    this.medicineArrCn = [];
                    this.saveMediceArr = [];
                    this.hasAllergy = '1'
                    this.getAllergyData()
                    if (id == null || id == undefined) {
                        this.isShowLoading = false;
                        return;
                    }
                    let res = await getPrePrescriptionById({ thirdPartyPrePrescriptionId: id })
                    if (res.code == 0) {
                        let info = res.result
                        let errList = info.drugList.filter(e => e.pref == null || e.pref == undefined)
                        let drugList = info.drugList.filter(e => e.pref != null || e.pref != undefined)
                        drugList.forEach((e) => {
                            e.num = e.quantity
                        })
                        if (errList.length != 0) {
                            // this.showDrugWarningInfo = errList.map(e => e.commonName || '')
                            this.showDrugWarningInfo = errList;
                            this.showDrugWarning = true;
                        }
                        this.formItem.name = info.userName
                        this.formItem.sex = info.sex.toString()
                        this.formItem.customAge = info.age
                        this.formItem.phoneNum = info.telephone
                        this.formItem.medicineType = info.medicineType.toString()
                        if (info.idCard && this.checkIDCard(info.idCard.toUpperCase())) {
                            this.formItem.customAge = this.getAgeByIdNO(info.idCard)
                        }
                        this.idNum = info.idCard
                        if (info.medicineType == 0) {
                            this.medicineArr = drugList
                        } else if (info.medicineType == 1) {
                            this.medicineArrCn = drugList
                        }
                    }
                } catch (error) {
                    this.isShowLoading = false;
                }
                this.isShowLoading = false;
            },
            // 打开统筹类型选择弹框
            openOverallPlanTypePopup() {

                this.showOverallPlanTypePopup  = true
            },
            // 获取统筹类型列表
            async getOverallPlanTypeData(organSign) {
                const { data } = await getOverallPlanTypeList(organSign)
                if(data.code === 0) {
                    // 判断是否需要显示统筹类型
                    console.log(this.overallPlanTypeMap);
                    this.containOverallPlanType = data.result.containOverallPlanType
                    this.overallPlanTypeMap = []
                    // 判断该机构是否有统筹类型
                    if(data.result.containOverallPlanType) {
                        // 遍历统筹类型生成数组
                        for(const key in data.result.overallPlanTypeMap) {
                            this.overallPlanTypeMap.push({
                                label: data.result.overallPlanTypeMap[key],
                                value: key
                            })
                        }
                        if(this.overallPlanTypeMap.length === 1) {
                            // 默认显示数组的第一个统筹类型
                            this.overallPlanTypeText = this.overallPlanTypeMap[0].label
                        }
                    }
                
                

                }
                console.log(this.overallPlanTypeMap);
                console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
            },
            // 选择统筹类型
            selectOverallPlanType(value) {
                this.overallPlanTypeText = value
                this.cancelOverallPlanTypePopup()
            },
            // 取消统筹类型选择
            cancelOverallPlanTypePopup() {
                this.showOverallPlanTypePopup = false
            }

  }
}
</script>

<style scoped lang="scss">
#root {
    /deep/ .van-field__label {
        color: #111734 !important;
    }
    .upload_text {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: 400;
        font-size: 15px;
        color: #111734;
    }
    .add_image {
        width: 86px;
        height: 86px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f8f8fb;
        border: 0.5px solid #d5d5d5;
        border-radius: 8px;
        box-sizing: border-box;
        img {
            width: 36px;
            height: 36px;
        }
    }
    /deep/ .van-uploader__preview-image {
        width: 86px;
        height: 86px;
        border-radius: 8px;
    }
    /deep/ {
        .van-radio__icon--checked .van-icon,
        .van-checkbox__icon--checked .van-icon {
            background-color: #01b956 !important;
            border-color: #01b956 !important;
        }
        .van-radio-group {
            .van-radio {
                margin: 0;
                &:last-child {
                    margin-left: 40px;
                }
            }
        }
        .van-radio__icon,
        .van-checkbox__icon {
            font-size: 20px;
        }
        .van-cell {
            padding-right: 15px;
        }
        .van-nav-bar__title {
            font-size: 16px;
            color: #333;
            font-weight: 600;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }
        .van-nav-bar__text {
            font-size: 15px;
            color: #333;
            font-weight: 400;
        }
        .van-field--disabled .van-field__label {
            color: #323233;
        }
        .inputMedicine {
            &.van-field--disabled {
                &:after {
                    box-sizing: border-box;
                    content: ' ';
                    pointer-events: none;
                    right: 0;
                    bottom: 0;
                    left: 0.42667rem;
                    border-bottom: 1px solid #f7f7f7;
                    -webkit-transform: scaleY(0.5);
                    transform: scaleY(0.5);
                }
            }
        }
        input,
        textarea {
            &::placeholder {
                color: #999;
            }
        }
        textarea {
            // padding-top: 10px;
        }
        .interrogationInfo-group {
            &[class*='van-hairline']::after {
                border-top: none;
                border-color: #f7f7f7;
            }
            [class*='van-hairline']::after {
                border: none;
                border-color: #f7f7f7;
            }
        }
        .van-cell::after {
            border-bottom: 1px solid #f7f7f7;
        }
    }
}
.telphone {
    display: block;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    color: #323233;
    line-height: inherit;
    text-align: left;
    background-color: transparent;
    border: 0;
    resize: none;
}
.pAge {
    position: relative;
    .customAge {
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-width: 0;
        margin: 0;
        padding: 0;
        color: #323233;
        line-height: inherit;
        text-align: left;
        background-color: transparent;
        border: 0;
        resize: none;
    }
    /deep/ .van-cell__value {
        .van-field__control {
            position: relative;
            &:after {
                content: '岁';
                position: absolute;
                right: 106px;
                top: 0;
            }
        }
    }
}
.buy-medicine {
    position: fixed;
    left: 0;
    right: 0;
    top: 49px;
    bottom: 0;
    background: #fff;
}
#root {
    // height: calc(100vh - 75px);
    padding: 55px 0 100px 0;
    &.setHeight {
        padding-top: 0;
    }
}
.interrogationInfo {
    height: calc(100% - 50px);
    .main {
        /deep/ .van-cell {
            font-size: 16px;
            min-height: 52px;
            padding-top: 0;
            padding-bottom: 0;
            color: #222;
        }
    }
}
.inquirytype {
    display: flex;
    align-items: center;
    .inquirytype-item {
        display: flex;
        align-items: center;
        margin-left: 15px;
        width: 165px;
        height: 57px;
        border-radius: 8px;
        box-shadow: 0px 0px 15px 0px rgba(48, 48, 60, 0.05);
        font-size: 16px;
        font-weight: 400;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        .inquirytype-item_photo {
            margin: 0 10px 0 25px;
        }
        &.active {
            background: rgba(1, 185, 86, 0.05) !important;
            border: 1px solid #01b956;
        }
        &:first-child {
            margin-left: 0;
        }
    }
    .inquiryText {
        position: relative;
        .inquiryHot {
            position: absolute;
            bottom: 45px;
            left: 124px;
            width: 50px;
            height: 21px;
        }
    }
}
.pd120 {
    // padding-bottom: 75px;
}
.content {
    position: relative;
    height: 100%;
    overflow-y: auto;
}
.setHeight {
    height: calc(100vh - 50px) !important;
}
.nameList {
    position: absolute;
    top: 115px;
    left: 15px;
    width: calc(100% - 30px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    z-index: 9999;
    max-height: 200px;
    overflow-y: scroll;
    .item {
        width: calc(100% - 30px);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 50px;
        height: 50px;
        .left {
            margin-right: 5px;
            flex: 1;
            display: flex;
            justify-content: space-between;
            //  span{
            //     width: 33%;
            //  }
            &:not(:last-of-type) {
                border-bottom: 1px solid rgba(246, 246, 246, 1);
            }
            .list-name {
                width: 55px;
                display: block;
                height: 100%;
            }
        }
    }
    .deleteIcon {
        padding: 5px 8px 0 12px;
    }
}
.main {
    position: relative;
    padding-left: 15px;
    .van-radio-group {
        display: flex;
        .van-radio {
            margin-right: 15px;
            /deep/ .van-radio__label {
                margin-left: 4px;
            }
        }
    }
    .main-agreement {
        padding-top: 10px;
        font-size: 14px;
        display: flex;
        align-items: flex-start;
        color: #999;
        .main-agreement_checked {
            margin-top: 2px;
        }
        & > p {
            flex: 1;
            margin: 0;
            padding: 0 10px;
            span {
                color: #01b956;
            }
        }
    }
}
.expect {
    &.van-cell--required {
        &:before {
            top: 20px;
        }
    }
}
/**过敏史及病情描述样式 */
.box {
    .box-top {
        padding-top: 15px;
        display: flex;
        justify-content: space-between;
        .box-title {
            margin: 0;
            color: rgba(51, 51, 51, 1);
            line-height: 28px;
            span {
                padding-left: 5px;
                font-size: 14px;
                color: #999;
            }
        }
        img {
            width: 18px;
            height: 18px;
        }
    }
    .tips-title {
        margin: 18px 0 0 0;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
    }
    .remark-area {
        // height: 100px;
        background: rgba(248, 248, 248, 1);
        border-radius: 8px;
        margin: 20px 0 10px;
    }
    .tips {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .tip {
            padding: 5px 15px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333;
            margin-right: 10px;
            margin-top: 10px;
            border: 1px solid rgba(248, 248, 248, 1);
            max-width: 285px;
            // white-space: pre-line;
            word-break: break-all;
            .van-icon-plus:before {
                vertical-align: middle;
                color: #c7c7cc;
            }
        }
        .active {
            background: rgba(243, 250, 255, 1);
            border-radius: 18px;
            border: 1px solid #01b956;
            font-weight: 500;
            color: #01b956 !important;
        }
    }
}
/**购物车中样式 */
.van-popup {
    width: 100%;
    .box {
        padding: 30px 15px 0 15px;
        width: calc(100% - 30px);

        .box-top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            .box-title {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                line-height: 28px;
            }
            img {
                width: 18px;
                height: 18px;
            }
        }
    }
}
.next-fixed-bottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 9px 15px;
    background: #fff;
    border-top: 1px solid #ededed;
    box-sizing: border-box;
}
.next {
    width: 100%;
    height: 50px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 50px;
    border-radius: 25px;
    background: #01b956;
    color: white;
    text-align: center;
}

.cell {
    /deep/ textarea {
        line-height: normal !important;
    }
    &.disabled-cell-input {
        padding: 15px;
        align-items: center;
        /deep/ .van-cell__title {
            color: #333;
        }
        &.input-selected {
            padding-top: 15px;
            padding-bottom: 15px;
            color: #333;
            align-items: baseline;
            box-sizing: border-box;
            &.birth-cell {
                align-items: center;
            }
            // /deep/ .van-cell__value {
            //   .van-field__control:disabled {
            //     color: #333 !important;
            //   }
            // }
        }
    }
    &.cell-new-catch {
        /deep/ .van-field__label {
            flex: 1;
        }
    }
}
// .disabled {
//   background: rgba(200, 200, 200, 1);
//   color: rgba(255, 255, 255, 1);
// }
.van-radio-group {
    height: 40px;
}
.van-cell {
    align-items: center;
}
.remark /deep/.van-cell__value {
    display: flex;
    align-items: center;
    & .van-field__body {
        width: 100%;
    }
}
.inputMedicine /deep/.van-cell__value {
    display: flex;
    align-items: center;
    & .van-field__body {
        width: 100%;
    }
}
.mask {
    background-color: rgba(255, 255, 255, 0);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
}

.search-list {
    background: white;
    padding-left: 30px;
    padding-right: 15px;
    height: 330px;
    overflow-y: scroll;
    padding-bottom: 65px;
    margin-top: 50px;
    padding-top: 35px;
    li {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 40px;
        height: 40px;
        border-bottom: 1px solid #ededed;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.search-list li.noli {
    border: none;
    margin-top: 50%;
    text-align: center;
    color: #999;
}
.search-main {
    height: calc(100% - 75px);
    background: #f7f7f7;
    .van-list {
        height: 100%;
    }
}

.search-end {
    padding-left: 15px;
    padding-bottom: 80px;
    margin-top: 80px;
    min-height: calc(100% - 70px);
    ul {
        padding-top: 9px;
    }
}
.nodata-wrap {
    // padding-right: 30px;
    // height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
    img {
        width: 160px;
        height: 130px;
    }
    p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-top: 5px;
    }
}
.search-end li.goods {
    padding: 15px 0;
    display: flex;
    position: relative;
    height: 46px;
    .goods-left {
        width: 220px;
        height: 100%;
        p {
            margin: 0;
            padding: 0;
        }
        .goods-name {
            line-height: 24px;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            span {
                display: block;
                box-sizing: border-box;
                padding: 0 5px;
                height: 18px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(239, 77, 77, 1);
                line-height: 18px;
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(239, 77, 77, 1);
                text-align: center;
                margin-right: 6px;
            }
            .goodsName {
                font-size: 17px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                width: 250px;
                display: block;
            }
        }
        .specifications {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 17px;
            margin: 5px 0 10px 0;
        }
        .producingArea {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .stepper {
        position: absolute;
        right: 20px;
        bottom: 24px;
    }
}
.add {
    position: absolute;
    right: 20px;
    bottom: 24px;
    border-radius: 50%;
}
.cart-goods {
    padding-left: 15px;
    height: 310px;
    overflow-y: scroll;
    margin-bottom: 30px;
    &::-webkit-scrollbar {
        display: none;
    }
}
.cart-goods li.goods {
    padding: 15px 0;
    display: flex;
    position: relative;
    .goods-left {
        width: 220px;
        height: 100%;
        p {
            margin: 0;
            padding: 0;
        }
        .goods-name {
            line-height: 24px;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            span {
                display: block;
                box-sizing: border-box;
                padding: 0 5px;
                height: 18px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(239, 77, 77, 1);
                line-height: 18px;
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(239, 77, 77, 1);
                text-align: center;
                margin-right: 6px;
            }
            .goodsName {
                font-size: 17px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                width: 250px;
                display: block;
            }
        }
        .specifications {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 17px;
            margin: 5px 0 10px 0;
        }
        .producingArea {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .stepper {
        position: absolute;
        right: 20px;
        bottom: 24px;
    }
}
.bottom-bar {
    background: white;
    z-index: 99;
    position: fixed;
    bottom: 0px;
    left: 0;
    display: flex;
    padding: 12px 15px 12px 24px;
    width: calc(100% - 39px);
    justify-content: space-between;
    align-items: center;
    // .cart {
    //   display: flex;
    //   flex-direction: column;
    //   align-items: center;
    //   justify-content: space-around;
    //   margin-right: 30px;
    //   height: 100%;
    //   .cart-icon {
    //     color: #7b7b7b;
    //   }
    //   .van-icon-shopping-cart-o:before {
    //     font-size: 30px;
    //   }
    //   span {
    //     width: 36px;
    //     height: 17px;
    //     font-size: 12px;
    //     font-family: PingFangSC-Regular, PingFang SC;
    //     font-weight: 400;
    //     color: rgba(102, 102, 102, 1);
    //     line-height: 17px;
    //   }
    // }
}
.closeMedicinePup {
    margin-bottom: 20px;
}
.disabled {
    background: rgba(200, 200, 200, 1);
    color: rgba(255, 255, 255, 1);
    border: 1px solid #c8c8c8;
}

.van-cell {
    &.no-border {
        font-family: inherit;
        &:after {
            border: none;
        }
    }
}
.search-tips-wrap {
    padding-top: 10px;
    margin-top: 2px;
    width: calc(100% - 30px);
    height: 34px;
    position: fixed;
    top: 92px;
    left: 15px;
    background: white;
    z-index: 9999;
    .search-tips {
        display: flex;
        align-items: center;
        margin: 0 auto;
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #99664d;
        line-height: 34px;
        background: #fff7ef;
        border-radius: 4px;
        padding: 0 15px;
    }
}
.dia-context{
  background: #FFFFFF;
  text-align: center;
  color: #999999;
  font-size: 14px;
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 30px 0;
  border-radius: 12px;

  .diagnose-finish-title{
    margin: 30px 0 10px;
    color: #111734;
    font-size: 1em;
    font-weight: 500;
    margin-bottom: 10rpx;
  }
}

.overallPlanType {
    color: red !important;
    .van-cell__value--alone {
        text-align: center !important;
        color: #000 !important;
        padding-top: 0.2rem !important;
        padding-bottom: 0.2rem !important;

    }
}
</style>
<style lang="scss">
p {
    margin: 0;
}
#root {
    // 筛选样式
    .search-box {
        background: white;
        width: 100%;
        display: flex;
        position: fixed;
        z-index: 1000;
        height: 53px;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;
        .qrcode {
            height: 38px;
            color: #01b956;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-right: 15px;
            span {
                font-size: 11px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
            }
            .patient-icon-qrcode,
            .patient-icon-qrcode::before {
                font-size: 24px;
            }
        }
        .form {
            width: 300px;
            position: relative;
            height: 60px;
        }
        .form-pad {
            width: 87%;
        }
        .search-input {
            width: 100%;
            padding-right: 0px;
            height: 60px;
            overflow: hidden;
            /deep/ .van-field__control {
                font-size: 13px !important;
            }
        }
        .search-input-pad {
            width: 100%;
        }
        .search-btn {
            height: 100%;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #01b956;
            display: block;
            line-height: 34px;
            text-align: center;
            position: absolute;
            top: 13px;
            right: 0;
            background: #d9ebff;
            border-radius: 17px;
            width: 58px;
            height: 34px;
        }
        .search-btn-pad {
            height: 100%;
            font-size: 15px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #333333;
            margin-right: 15px;
            display: flex;
            align-items: center;
        }
    }

    .first-bar {
        z-index: 1000;
    }
    .z-index_3000 {
        z-index: 5000 !important;
    }
    .van-nav-bar__text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
    }
    //筛选样式
    .sign-content {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        padding: 45px 15px 15px;
        background: #f7f7f7;
        z-index: 9999;
        box-sizing: border-box;
        overflow-y: auto;
        .nav-bar {
            &.van-nav-bar {
                background: #fff;
            }
        }
        h4 {
            font-size: 16px;
        }
        h5 {
            font-size: 14px;
        }
        p {
            font-size: 14px;
            text-indent: 2em;
        }
    }
}
.cart {
    width: 60px;
    padding-top: 27px;
    font-size: 12px;
    color: #666;
    background: url(../../icons/medicineList.png) no-repeat center 0;
    background-size: 24px 24px;
    position: relative;
    margin-right: 24px;
    white-space: nowrap;
    & span {
        width: 15px;
        height: 15px;
        background: rgba(239, 77, 77, 1);
        border: 1px solid rgba(239, 77, 77, 1);
        font-size: 12px;
        color: #fff;
        display: block;
        position: absolute;
        top: -7px;
        right: 5px;
        text-align: center;
        border-radius: 100%;
        line-height: 16px;
    }
}
.van-popup {
    height: 75vh;
}
.van-popup.mainsuit-popup .footerbut {
    position: absolute;
    bottom: 20px;
    width: calc(100% - 30px);
}
.van-popup.mainsuit-popup {
    .van-cell-group {
        width: calc(100% - 30px);
        margin-left: 15px;
        background: #f8f8f8;
        .remark-area {
            background: #f8f8f8;
        }
    }
}
.diagnose.van-cell--required::before {
    top: 15px;
}
.checkBox {
    font-size: 17px;
    font-weight: 500;
    .van-checkbox__icon--round .van-icon {
        border-radius: 0;
    }
}

</style>
